import React, { useState, useEffect, Fragment, useContext, useCallback, memo, useReducer, useMemo } from 'react';
import merge from 'lodash/merge';
import { css, forBrands, jsx, getFontWeight, StitchInverseStyleProvider } from '@core-ui/react-stitch';
import { useAppState as useAppState$1, extendableUseAppState } from '@core-ui/app-state-provider';
import ErrorBoundary from '@core-ui/error-boundary';
import { FeatureFlagsContext } from '@core-ui/feature-flags';
import { useLocalize } from '@core-ui/localization-provider';
import { PersonalizationContext } from '@core-ui/personalization-provider';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { ComposableButton, Capitalization } from '@core-ui/composable-button';
import classnames from 'classnames';
import he from 'he';
import duration from 'dayjs/plugin/duration';
import { AnimationStatus } from '@core-ui/button';
import { Brands } from '@core-ui/utility';
import DimensionStockIndicator from '@core-ui/stock-indicator';
import { ReviewRatings } from '@core-ui/review-ratings';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

function errorMessageStyles(theme) {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    ", "\n    position: relative;\n    margin-bottom: 1.125rem;\n    border-width: 2px 2px 2px 8px;\n    border-style: solid;\n    font-size: 0.875rem;\n    border-color: ", ";\n    padding: 0.625rem 2rem 0.625rem 2.2rem;\n    width: auto;\n    flex: auto;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 0.5rem;\n      height: 1.25rem;\n      width: 1.25rem;\n      transform: translateY(-50%);\n      background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGN4PSIxMCIgY3k9IjEwIiByPSIxMCIgZmlsbD0iI0QwMDAwMCIvPjxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTExLjU3OSAxNC4zNGMwIC44MjgtLjY3MiAxLjQ1LTEuNTc1IDEuNDUtLjkwNCAwLTEuNTgzLS42MjItMS41ODMtMS40NSAwLS44MzIuNjc3LTEuNDU2IDEuNTgzLTEuNDU2LjkwNSAwIDEuNTc1LjYyMyAxLjU3NSAxLjQ1NnpNOC42ODUgNC4yMWgyLjYzdjcuMjU3aC0yLjYzVjQuMjExeiIvPjwvZz48L3N2Zz4=)\n        no-repeat;\n    }\n  "], ["\n    color: ", ";\n    ", "\n    position: relative;\n    margin-bottom: 1.125rem;\n    border-width: 2px 2px 2px 8px;\n    border-style: solid;\n    font-size: 0.875rem;\n    border-color: ", ";\n    padding: 0.625rem 2rem 0.625rem 2.2rem;\n    width: auto;\n    flex: auto;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 0.5rem;\n      height: 1.25rem;\n      width: 1.25rem;\n      transform: translateY(-50%);\n      background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGN4PSIxMCIgY3k9IjEwIiByPSIxMCIgZmlsbD0iI0QwMDAwMCIvPjxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTExLjU3OSAxNC4zNGMwIC44MjgtLjY3MiAxLjQ1LTEuNTc1IDEuNDUtLjkwNCAwLTEuNTgzLS42MjItMS41ODMtMS40NSAwLS44MzIuNjc3LTEuNDU2IDEuNTgzLTEuNDU2LjkwNSAwIDEuNTc1LjYyMyAxLjU3NSAxLjQ1NnpNOC42ODUgNC4yMWgyLjYzdjcuMjU3aC0yLjYzVjQuMjExeiIvPjwvZz48L3N2Zz4=)\n        no-repeat;\n    }\n  "])), theme.color.bk, theme.crossBrand.font.primary, theme.crossBrand.color.err1);
}
var templateObject_1;

function checkError(response) {
    if (response.ok) {
        return response;
    }
    var status = response.status;
    throw Error(status.toString());
}
function useFetch(url, options) {
    if (options === void 0) { options = {}; }
    var _a = useState(null), status = _a[0], setStatus = _a[1];
    var _b = useState(null), data = _b[0], setData = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    function fetchOnce() {
        setStatus('pending');
        setData(null);
        setError(null);
        return fetch(url, options)
            .then(checkError)
            .then(function (res) { return res.json(); })
            .then(function (res) {
            setData(res);
            setStatus('complete');
            setError(null);
        })
            .catch(function (err) {
            setData(null);
            setStatus('error');
            setError(err);
        });
    }
    useEffect(function () {
        fetchOnce();
    }, [url]);
    return {
        fetchOnce: fetchOnce,
        status: status,
        data: data,
        error: error,
    };
}

var apiBaseUrl = 'https://readservices-b2c.powerreviews.com';
var useReviewRatings = function (_a) {
    var reviews = _a.reviews, pid = _a.pid, _b = _a.locale, locale = _b === void 0 ? 'en_US' : _b, powerReviewsConfig = _a.powerReviewsConfig, powerReviewsAllLocaleEnabled = _a.powerReviewsAllLocaleEnabled;
    if (reviews) {
        return reviews;
    }
    var merchantId = powerReviewsConfig.merchantId, apiKey = powerReviewsConfig.apiKey;
    var sixDigitPid = pid === null || pid === void 0 ? void 0 : pid.substring(0, 6);
    var prLocale = powerReviewsAllLocaleEnabled ? 'all' : locale;
    var url = apiBaseUrl + "/m/" + merchantId + "/l/" + prLocale + "/product/" + sixDigitPid + "/snippet?_noconfig=true";
    var fetchOptions = {
        headers: {
            Authorization: apiKey,
        },
        timeout: 1000,
    };
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var data = useFetch(url, fetchOptions).data;
    var rollup = ((data === null || data === void 0 ? void 0 : data.results[0]) || {}).rollup;
    return { starRating: rollup === null || rollup === void 0 ? void 0 : rollup.average_rating, reviewCount: rollup === null || rollup === void 0 ? void 0 : rollup.review_count };
};

var QUANTITY_CHANGE = 'QUANTITY_CHANGE';
var VARIANT_CHANGE = 'VARIANT_CHANGE';
var DIMENSION_CHANGE = 'DIMENSION_CHANGE';
var ADD_TO_BAG_REQUEST = 'ADD_TO_BAG_REQUEST';
var ADD_TO_BAG_RESPONSE = 'ADD_TO_BAG_RESPONSE';
var ADD_TO_BAG_SIZE_VALIDATION = 'ADD_TO_BAG_SIZE_VALIDATION';
var setDefaultDimension = function (_a) {
    var variant = _a.variant;
    var singleUnitDimensions = variant && variant.dimensions.filter(function (dimension) { return dimension.measurements.length === 1; });
    var selectedDimensions = {};
    singleUnitDimensions === null || singleUnitDimensions === void 0 ? void 0 : singleUnitDimensions.forEach(function (dimension) {
        var firstAndOnlyMeasurement = dimension.measurements[0];
        selectedDimensions[dimension.label] = firstAndOnlyMeasurement;
    });
    return selectedDimensions;
};
/**
 * On variant change, keep only the dimension selections that are present in the new variant
 */
var getSelectedDimensions = function (_a) {
    var _b;
    var variant = _a.variant, currentDimensions = _a.currentDimensions;
    var selectedDimensions = {};
    (_b = variant.dimensions) === null || _b === void 0 ? void 0 : _b.forEach(function (variantDimension) {
        if (currentDimensions[variantDimension.label] &&
            variantDimension.measurements.includes(currentDimensions[variantDimension.label])) {
            selectedDimensions[variantDimension.label] = currentDimensions[variantDimension.label];
        }
    });
    return selectedDimensions;
};
function initQuickAddState(variants) {
    var selectedDimensions = setDefaultDimension({
        variant: variants[0],
    });
    return {
        selectedVariant: variants[0],
        selectedDimensions: selectedDimensions,
        outOfStockDimensions: getAllOutOfStockDimensions({
            variant: variants[0],
            selectedDimensions: selectedDimensions,
        }),
        selectedSku: findSku({
            variant: variants[0],
            selectedDimensions: selectedDimensions,
        }),
        inProgress: false,
        response: {},
        unselectedDimensions: '',
        variants: variants.map(function (variant) { return (__assign(__assign({}, variant), { dimensions: variant.dimensions.map(function (d) { return (__assign(__assign({}, d), { measurements: d.measurements.map(function (m) { return m; }) })); }) })); }),
        quantity: 1,
    };
}
function quickAddReducer(state, action) {
    var _a;
    switch (action.type) {
        case VARIANT_CHANGE: {
            var variant_1 = action.payload.variant;
            var currentVariant = state.variants.filter(function (v) { return v.id === variant_1.id; })[0];
            variant_1.dimensions = currentVariant.dimensions.map(function (d) { return (__assign(__assign({}, d), { measurements: d.measurements.map(function (m) { return m; }) })); });
            var selectedDimensions = getSelectedDimensions({ variant: variant_1, currentDimensions: state.selectedDimensions });
            var selectedSku = findSku({
                variant: variant_1,
                selectedDimensions: selectedDimensions,
            });
            var outOfStockDimensions = getAllOutOfStockDimensions({
                variant: variant_1,
                selectedDimensions: selectedDimensions,
            });
            return __assign(__assign({}, state), { response: {}, selectedDimensions: selectedDimensions, selectedVariant: getValidMeasurements({ selectedDimensions: selectedDimensions, variant: variant_1 }), outOfStockDimensions: outOfStockDimensions,
                selectedSku: selectedSku, unselectedDimensions: selectedSku
                    ? ''
                    : getUnselectedDimensionLabels({
                        dimensions: variant_1.dimensions,
                        selectedDimensions: selectedDimensions,
                    }) });
        }
        case QUANTITY_CHANGE:
            return __assign(__assign({}, state), { quantity: action.payload.quantity, inProgress: false, response: {} });
        case DIMENSION_CHANGE: {
            var _b = action.payload, dimension = _b.dimension, measurement = _b.measurement;
            var selectedDimensions = __assign(__assign({}, state.selectedDimensions), (_a = {}, _a[dimension.label] = measurement, _a));
            var outOfStockDimensions = __assign(__assign({}, state.outOfStockDimensions), getAllOutOfStockDimensions({
                variant: state.selectedVariant,
                selectedDimensions: selectedDimensions,
            }));
            var selectedSku = findSku({
                variant: state.selectedVariant,
                selectedDimensions: selectedDimensions,
            });
            return __assign(__assign({}, state), { response: {}, selectedDimensions: selectedDimensions, selectedVariant: getValidMeasurements({
                    selectedDimensions: selectedDimensions,
                    variant: state.variants.find(function (_a) {
                        var id = _a.id;
                        return id === state.selectedVariant.id;
                    }),
                }), selectedSku: selectedSku,
                outOfStockDimensions: outOfStockDimensions, unselectedDimensions: selectedSku
                    ? ''
                    : getUnselectedDimensionLabels({
                        dimensions: state.selectedVariant.dimensions,
                        selectedDimensions: selectedDimensions,
                    }) });
        }
        case ADD_TO_BAG_SIZE_VALIDATION:
            return __assign(__assign({}, state), { unselectedDimensions: getUnselectedDimensionLabels({
                    dimensions: state.selectedVariant.dimensions,
                    selectedDimensions: state.selectedDimensions,
                }) });
        case ADD_TO_BAG_REQUEST:
            return __assign(__assign({}, state), { inProgress: true });
        case ADD_TO_BAG_RESPONSE:
            return __assign(__assign({}, state), { response: action.payload.response, inProgress: false });
        default: {
            return state;
        }
    }
}
/**
 * returns all valid sizes based on selection
 */
function getValidMeasurements(_a) {
    var selectedDimensions = _a.selectedDimensions, variant = _a.variant;
    if (Object.keys(selectedDimensions).length && variant.dimensions.length > 1) {
        var updatedVariant = __assign({}, variant);
        var validSku = variant.skus.filter(function (sku) {
            return sku.dimensions.find(function (_a) {
                var label = _a.label, measurement = _a.measurement;
                return selectedDimensions[label] && measurement === selectedDimensions[label];
            });
        });
        var dimensionsToUpdate_1 = {};
        Object.entries(selectedDimensions).forEach(function (_a) {
            var selectedLabel = _a[0];
            return variant.dimensions
                .filter(function (_a) {
                var label = _a.label;
                return label !== selectedLabel;
            })
                .forEach(function (_a) {
                var label = _a.label;
                dimensionsToUpdate_1[label] = new Set();
            });
        });
        validSku.forEach(function (sku) {
            sku.dimensions.forEach(function (_a) {
                var label = _a.label, measurement = _a.measurement;
                dimensionsToUpdate_1[label] && dimensionsToUpdate_1[label].add(measurement);
            });
        });
        updatedVariant.dimensions = variant.dimensions.map(function (_a) {
            var label = _a.label, measurements = _a.measurements;
            if (dimensionsToUpdate_1[label]) {
                var expectedMeasurements_1 = Array.from(dimensionsToUpdate_1[label]);
                return {
                    label: label,
                    measurements: measurements.filter(function (m) { return expectedMeasurements_1.includes(m); }),
                };
            }
            return {
                label: label,
                measurements: measurements,
            };
        });
        return updatedVariant;
    }
    return variant;
}
// gets out of stock measurements for all dimensions other than the given dimension
function getOutOfStockMeasurements(_a) {
    var variant = _a.variant, dimension = _a.dimension, selectedMeasurement = _a.selectedMeasurement;
    var dimensionsToUpdate = Object.fromEntries(variant.dimensions
        .filter(function (d) {
        return d.label !== dimension.label;
    })
        .map(function (d) { return [d.label, new Set()]; }));
    variant.skus
        .filter(function (sku) {
        var dimensionToCheck = sku.dimensions.find(function (d) { return d.label === dimension.label; });
        return dimensionToCheck && dimensionToCheck.measurement === selectedMeasurement && !sku.inStock;
    })
        .forEach(function (sku) {
        sku.dimensions.forEach(function (_a) {
            var label = _a.label, measurement = _a.measurement;
            dimensionsToUpdate[label] && dimensionsToUpdate[label].add(measurement);
        });
    });
    return dimensionsToUpdate;
}
function isMeasurementAvailableInAnySku(measurement, skus) {
    return skus.some(function (_a) {
        var inStock = _a.inStock, dimensions = _a.dimensions;
        return inStock && dimensions.some(function (d) { return d.measurement === measurement; });
    });
}
function getAllOutOfStockDimensions(_a) {
    var _b;
    var _c;
    var variant = _a.variant, selectedDimensions = _a.selectedDimensions;
    if (((_c = variant.dimensions) === null || _c === void 0 ? void 0 : _c.length) === 1) {
        return _b = {},
            _b[variant.dimensions[0].label] = new Set(variant.dimensions[0].measurements.filter(function (m) { return !isMeasurementAvailableInAnySku(m, variant.skus); })),
            _b;
    }
    var outOfStock = {};
    Object.entries(selectedDimensions).forEach(function (_a) {
        var _b;
        var label = _a[0], measurement = _a[1];
        outOfStock = __assign(__assign({}, outOfStock), getOutOfStockMeasurements({
            variant: variant,
            dimension: (_b = variant.dimensions) === null || _b === void 0 ? void 0 : _b.find(function (d) { return d.label === label; }),
            selectedMeasurement: measurement,
        }));
    });
    return outOfStock;
}
function findSku(_a) {
    var _b;
    var variant = _a.variant, selectedDimensions = _a.selectedDimensions;
    return (((_b = variant.skus) === null || _b === void 0 ? void 0 : _b.find(function (sku) {
        var _a;
        return (sku.inStock && ((_a = sku.dimensions) === null || _a === void 0 ? void 0 : _a.length) &&
            sku.dimensions.every(function (_a) {
                var label = _a.label, measurement = _a.measurement;
                return measurement === selectedDimensions[label];
            }));
    })) || null);
}
function getUnselectedDimensionLabels(_a) {
    var dimensions = _a.dimensions, selectedDimensions = _a.selectedDimensions;
    return dimensions
        .filter(function (dimension) { return !selectedDimensions[dimension.label]; })
        .map(function (_a) {
        var label = _a.label;
        return label;
    })
        .join(' & ')
        .toLowerCase();
}

var isMergedVariant = function (variant) { return !!variant.link; };
var getRegularVariants = function (variants) {
    var isRegularVariant = function (variant) { return !isMergedVariant(variant); };
    return variants.filter(isRegularVariant);
};

function isVariantInStock(_a) {
    var inStock = _a.inStock;
    return inStock || typeof inStock === 'undefined';
}

var sdsHeadingE = function (theme) {
    var textFontSize = forBrands(theme, {
        gap: function () { return '0.933rem'; },
        gapfs: function () { return '0.933rem'; },
        on: function () { return '0.9rem'; },
        br: function () { return '0.8125rem'; },
        brfs: function () { return '0.8125rem'; },
        at: function () { return '1rem'; },
        default: function () { return '0.8125rem'; },
    });
    var fontExtras = forBrands(theme, {
        at: function () { return "\n      font-variant-ligatures: none;\n      letter-spacing: 0.5px;\n    "; },
    });
    var textColor = forBrands(theme, {
        at: function () { return theme.color.g1; },
        br: function () { return theme.color.g2; },
        brfs: function () { return theme.color.g2; },
        gap: function () { return theme.color.b1; },
        gapfs: function () { return theme.color.b1; },
        on: function () { return theme.color.b1; },
    });
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", ";\n    ", "\n  "], ["\n    color: ", ";\n    font-size: ", ";\n    ", "\n  "])), textColor, textFontSize, fontExtras);
};
var sdsBodyA = function (theme) {
    var fontHeight = forBrands(theme, {
        gap: function () { return '1.38'; },
        gapfs: function () { return '1.38'; },
        on: function () { return '1.38'; },
        br: function () { return '1.43'; },
        brfs: function () { return '1.43'; },
        at: function () { return '1.4'; },
    });
    var fontColor = forBrands(theme, {
        gap: function () { return theme.color.g2; },
        gapfs: function () { return theme.color.g2; },
        on: function () { return theme.color.g2; },
        br: function () { return theme.color.g1; },
        brfs: function () { return theme.color.g1; },
        at: function () { return theme.color.g1; },
    });
    var fontSize = forBrands(theme, {
        gap: function () { return '0.867rem'; },
        gapfs: function () { return '0.867rem'; },
        on: function () { return '0.867rem'; },
        br: function () { return '0.875rem'; },
        brfs: function () { return '0.875rem'; },
        at: function () { return '0.875rem'; },
    });
    var fontExtras = forBrands(theme, {
        at: function () { return "\n      font-variant-ligatures: none;\n    "; },
    });
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    line-height: ", ";\n    color: ", ";\n    font-size: ", ";\n    ", "\n    font-weight: lighter;\n    ", "\n  "], ["\n    line-height: ", ";\n    color: ", ";\n    font-size: ", ";\n    ", "\n    font-weight: lighter;\n    ", "\n  "])), fontHeight, fontColor, fontSize, theme.font.primary, fontExtras);
};
var visuallyHide = function () {
    return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    position: absolute;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n  "], ["\n    position: absolute;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n  "])));
};
var templateObject_3, templateObject_4, templateObject_7;

var backOrderNotificationStyles = function (isQuickAddRedesignEnabled) { return function (theme) {
    return css(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n    ", "\n    line-height: 1.25;\n    padding: 0.625rem 2rem 0.625rem 2.2rem;\n    margin-bottom: 1.125rem;\n    border-width: 2px 2px 2px 8px;\n    border-style: solid;\n    position: relative;\n    color: ", ";\n    border-color: #5cabf7;\n    font-weight: 400;\n    font-size: 0.875rem;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 0.5rem;\n      height: 1.25rem;\n      width: 1.25rem;\n      transform: translateY(-50%);\n      background: url(\"data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm1.315 8.533h-2.63v7.256h2.63V8.533zM9.996 4.21c-.903 0-1.575.621-1.575 1.449 0 .833.67 1.456 1.575 1.456.906 0 1.583-.624 1.583-1.456 0-.828-.679-1.45-1.583-1.45z' fill='%235CABF7' /%3E%3C/svg%3E\")\n        no-repeat;\n    }\n  "], ["\n    ", "\n    line-height: 1.25;\n    padding: 0.625rem 2rem 0.625rem 2.2rem;\n    margin-bottom: 1.125rem;\n    border-width: 2px 2px 2px 8px;\n    border-style: solid;\n    position: relative;\n    color: ", ";\n    border-color: #5cabf7;\n    font-weight: 400;\n    font-size: 0.875rem;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 0.5rem;\n      height: 1.25rem;\n      width: 1.25rem;\n      transform: translateY(-50%);\n      background: url(\"data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm1.315 8.533h-2.63v7.256h2.63V8.533zM9.996 4.21c-.903 0-1.575.621-1.575 1.449 0 .833.67 1.456 1.575 1.456.906 0 1.583-.624 1.583-1.456 0-.828-.679-1.45-1.583-1.45z' fill='%235CABF7' /%3E%3C/svg%3E\")\n        no-repeat;\n    }\n  "])), sdsBodyA(theme), isQuickAddRedesignEnabled ? theme.color.b2 : 'inherit');
}; };
var templateObject_1$1;

/** @jsx jsx */
dayjs.extend(utc);
var formatDate = function (str) { return dayjs.utc(str).format('MMMM D, YYYY'); };
var BackOrderMessage = function (_a) {
    var selectedSku = _a.selectedSku, isQuickAddRedesignEnabled = _a.isQuickAddRedesignEnabled;
    var localize = useLocalize().localize;
    var date = formatDate((selectedSku === null || selectedSku === void 0 ? void 0 : selectedSku.backOrderDate) || '');
    var message = localize('quickAdd.onBackOrderMessage', { date: date });
    var ariaLabel = localize('quickAdd.onBackOrderMessage.ariaLabel', { date: date });
    return (jsx(React.Fragment, null, selectedSku && !!selectedSku.backOrderDate && (jsx("div", { "aria-label": ariaLabel, "aria-live": "polite", className: "quick-add__backorder-messaging", css: backOrderNotificationStyles(isQuickAddRedesignEnabled), role: "alert" },
        jsx("span", { "aria-hidden": "true" }, message)))));
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var checkForServerErrors = function (response) {
    return response.networkErrorCode
        ? {
            errorCode: response.networkErrorCode,
            moreInfo: response.networkError || 'Network Error',
        }
        : null;
};
var checkForInlineBagErrors = function (response) {
    var _a = response.inlineBagModelData || {}, bagError = _a.bagError, errorAddToBag = _a.errorAddToBag;
    if (bagError || errorAddToBag) {
        return {
            errorCode: 200,
            moreInfo: (bagError === null || bagError === void 0 ? void 0 : bagError.errorMsg) || (errorAddToBag === null || errorAddToBag === void 0 ? void 0 : errorAddToBag.errorMsg) || 'Unknown bag error returned from server',
        };
    }
    return null;
};
var checkForBagErrors = function (response) {
    var _a = response.inlineBagModelData || {}, subTotal = _a.subTotal, itemCount = _a.itemCount;
    var bagErrors = !subTotal ? 'Bag subtotal not set' : 'Bag itemCount not set';
    if (!(subTotal && itemCount)) {
        return {
            errorCode: 200,
            moreInfo: bagErrors,
        };
    }
    return null;
};
var normalizeLegacyResponse = function (response) {
    var serverErrors = checkForServerErrors(response);
    var inlineBagErrors = checkForInlineBagErrors(response);
    var bagErrors = checkForBagErrors(response);
    if (serverErrors || inlineBagErrors || bagErrors) {
        var errors = [serverErrors, inlineBagErrors, bagErrors];
        return {
            status: 'ERROR',
            errors: errors.filter(function (err) { return !!err; }),
        };
    }
    var inlineBagModelData = response.inlineBagModelData;
    var itemCount = inlineBagModelData.itemCount, inlineBagItems = inlineBagModelData.inlineBagItems, subTotal = inlineBagModelData.subTotal;
    var _a = inlineBagItems[0].itemSubtotal, itemSubtotal = _a === void 0 ? '' : _a;
    return {
        inlineBagModelData: inlineBagModelData,
        itemCount: itemCount,
        itemSubtotal: itemSubtotal,
        subTotal: subTotal,
        status: 'SUCCESS',
    };
};
var catchHttpError = function (response) {
    if (response.ok) {
        return response;
    }
    var contentType = response.headers.get('content-type');
    var jsonType = 'application/json';
    if (contentType === null || contentType === void 0 ? void 0 : contentType.startsWith(jsonType)) {
        return response.json().then(function (err) {
            throw __assign$1(__assign$1({}, err), { status: response.status });
        });
    }
    return response.text().then(function (err) {
        throw new Error("" + (response.status || err));
    });
};

var addToBagBrandCodes = {
    gap: 'GP',
    br: 'BR',
    on: 'ON',
    at: 'AT',
    gapfs: 'GPFS',
    brfs: 'BRFS',
};
var legacyRequestBuilder = function (_a) {
    var skuId = _a.skuId, _b = _a.quantity, quantity = _b === void 0 ? '1' : _b, cid = _a.cid;
    var queryParams = "?skuid=" + skuId + "&quantity" + skuId + "=" + quantity + "&sfl" + skuId + "=false";
    return cid ? queryParams + "&cid" + skuId + "=" + cid : queryParams + "&cid" + skuId;
};
var leapfrogRequestBuilder = function (_a) {
    var skuId = _a.skuId, _b = _a.quantity, quantity = _b === void 0 ? 1 : _b;
    return ({
        sku: skuId,
        quantity: quantity,
    });
};

/**
 * Adds a custom formatter for add to bag as leapfrog service sends raw price
 * and generic currency formatter from core-ui would not be suffice PDP currency formats
 *
 * Uses translations to convert raw price to corresponding currency
 * coverts as below
 * en_US -  12 -> $12.00,       34.99 -> $34.99
 * en_CA -  12 -> $CA12.00,     34.99 -> $CA34.99
 * fr_CA -  12 -> 12,00 $ CA,   34.99 -> 34,99  $ CA
 */
var formatPriceByLocaleSwitch = function (price, locale) {
    return ({
        en_US: "$" + price,
        en_CA: "CA$" + price,
        fr_CA: price + " $ CA",
        default: price,
    }[locale]);
};
var currencyFormatter = function (locale) {
    if (locale === void 0) { locale = 'en_US'; }
    var formatter = function (price) {
        if (price === void 0) { price = 0; }
        var correctedPrice = locale === 'fr_CA' ? price.toFixed(2).replace(/\./g, ',') : price.toFixed(2);
        return formatPriceByLocaleSwitch(correctedPrice, locale) || formatPriceByLocaleSwitch(correctedPrice, 'default');
    };
    return formatter;
};

var en_US = {
	"addToBag.outOfStock": "We're sorry, the item in the size and color you wish to add to bag just sold out. Other selections may be available.",
	"addToBag.genericError": "We are sorry, there has been an error adding this item to bag.",
	"addToBag.maxLineItemLimitReached": "You have added the maximum number of items to your Shopping Bag. Make room in your bag by removing unwanted items, or place your order now.",
	"addToBag.maxQuantityReached": "We're sorry, but only {{maxQuantityAllowed}} {{name}} may be purchased in one order.",
	"addToBag.partialSuccess": "Only {{quantityAdded}} items are in stock at this time and have been added to your bag. We apologize for the inconvenience."
};

var en_CA = {
	"addToBag.outOfStock": "We're sorry, the item in the size and color you wish to add to bag just sold out. Other selections may be available.",
	"addToBag.genericError": "We are sorry, there has been an error adding this item to bag.",
	"addToBag.maxLineItemLimitReached": "You have added the maximum number of items to your Shopping Bag. Make room in your bag by removing unwanted items, or place your order now.",
	"addToBag.maxQuantityReached": "We're sorry, but only {{maxQuantityAllowed}} {{name}} may be purchased in one order.",
	"addToBag.partialSuccess": "Only {{quantityAdded}} items are in stock at this time and have been added to your bag. We apologize for the inconvenience."
};

var fr_CA = {
	"addToBag.outOfStock": "Veuillez nous excuser, l`article que vous désirez ajouter à votre panier n`est plus disponible dans la taille et la couleur demandées. Veuillez faire un autre choix.",
	"addToBag.genericError": "Veuillez nous excuser, une erreur s`est produite lors de l`ajout de cet article à votre panier.",
	"addToBag.maxLineItemLimitReached": "Vous avez ajouté le numéro maximum d`articles à votre panier. Faites de l`espace dans votre panier en enlevant les articles non désirés ou passez votre commande dès maintenant.",
	"addToBag.maxQuantityReached": "Nous sommes désolés, mais {{maxQuantityAllowed}} {{name}} uniquement peuvent être achetés par commande.",
	"addToBag.partialSuccess": "Seulement {{quantityAdded}} articles sont en stock actuellement et ont été ajoutés à votre panier. Nous nous excusons de tout inconvénient occasionné."
};

var config = {
    en_US: en_US,
    en_CA: en_CA,
    fr_CA: fr_CA,
};
function translationsConfig (locale) {
    return config[locale];
}

var _a;
var OUT_OF_STOCK_ERR = 'BAGCAT-4010';
var MAX_QUANTITY_LIMIT_ERR = 'BAGCAT-8007';
var PARTIAL_SUCCESS_ERR = 'BAGICM-3070';
var BOPIS_RESERVE_FAIL = 'BAGICM-3000';
var MAX_LINE_ITEM_ERR = 'BAGAPI-2060';
var DEFAULT_BAG_ERROR = 'default';
var responseConfig = (_a = {},
    _a[OUT_OF_STOCK_ERR] = 'addToBag.outOfStock',
    _a[PARTIAL_SUCCESS_ERR] = 'addToBag.partialSuccess',
    _a[MAX_QUANTITY_LIMIT_ERR] = 'addToBag.maxQuantityReached',
    _a[MAX_LINE_ITEM_ERR] = 'addToBag.maxLineItemLimitReached',
    _a[BOPIS_RESERVE_FAIL] = 'addToBag.outOfStock',
    _a[DEFAULT_BAG_ERROR] = 'addToBag.genericError',
    _a);
function getTranslations(locale) {
    var config = translationsConfig(locale || 'en_US');
    function translations(_a) {
        var errorCode = _a.errorCode, args = __rest$1(_a, ["errorCode"]);
        if (responseConfig[errorCode]) {
            var translationsKey_1 = responseConfig[errorCode];
            var translations_1 = config[translationsKey_1];
            Object.keys(args).forEach(function (key) {
                translations_1 = translations_1.replace("{{" + key + "}}", args[key]);
            });
            return translations_1;
        }
        var translationsKey = responseConfig[DEFAULT_BAG_ERROR];
        return config[translationsKey];
    }
    return translations;
}

var leapfrogResponseFormatter = function (_a) {
    var locale = _a.locale, response = _a.response, actualQuantity = _a.actualQuantity, sku = _a.sku;
    if (response.errorCode || !response.items || !response.items.length) {
        var translations = getTranslations(locale);
        return {
            status: 'ERROR',
            errors: [
                {
                    moreInfo: translations({ errorCode: response.errorCode }),
                    errorCode: response.errorCode,
                },
            ],
        };
    }
    var getLocalizedPrice = function (locale) {
        return currencyFormatter(locale);
    };
    var formatCurrency = getLocalizedPrice(locale);
    var subTotal = response.charges.subTotal, productPrice = response.items[0].productPrice, productData = response.productData, totalBagQuantity = response.totalBagQuantity;
    var _b = productData[0], color = _b.color, eligibleReturnLocationCode = _b.eligibleReturnLocationCode, inventoryStatusId = _b.inventoryStatusId, priceTypeId = _b.priceTypeId, productImage = _b.productImage, productStyleDescription = _b.productStyleDescription, productURL = _b.productURL, size = _b.size, styleNumber = _b.styleNumber;
    var formattedResponse = {
        subTotal: formatCurrency(subTotal),
        itemCount: totalBagQuantity,
        status: 'SUCCESS',
        itemSubtotal: formatCurrency(productPrice === null || productPrice === void 0 ? void 0 : productPrice.salePrice),
        inlineBagModelData: {
            inlineBagItems: [
                {
                    colorDescription: color,
                    inventoryLevel: inventoryStatusId,
                    itemSubtotal: formatCurrency(productPrice === null || productPrice === void 0 ? void 0 : productPrice.salePrice),
                    listPrice: formatCurrency(productPrice === null || productPrice === void 0 ? void 0 : productPrice.regularPrice),
                    productLink: "/" + productURL,
                    quantity: actualQuantity,
                    returnType: eligibleReturnLocationCode,
                    sellPrice: formatCurrency(productPrice === null || productPrice === void 0 ? void 0 : productPrice.salePrice),
                    shouldShowSalePrice: (productPrice === null || productPrice === void 0 ? void 0 : productPrice.regularPrice) !== (productPrice === null || productPrice === void 0 ? void 0 : productPrice.salePrice),
                    siImageURI: productImage === null || productImage === void 0 ? void 0 : productImage.summaryImagePath,
                    sku: sku,
                    skuDescription: size,
                    styleDescription: productStyleDescription,
                    priceType: priceTypeId,
                    styleId: styleNumber,
                },
            ],
        },
    };
    return formattedResponse;
};

var LEAP_FROG_ADD_TO_BAG_URL = '/commerce/shopping-bags/';
var requestHeader = function (_a) {
    var _b = _a.clientId, clientId = _b === void 0 ? 'PDP' : _b, market = _a.market, brand = _a.brand, _c = _a.oidcUrl, oidcUrl = _c === void 0 ? '' : _c;
    var headers = {
        market: market,
        brand: brand,
        channel: 'WEB',
        'X-Gap-ApiMode': 'leapfrog',
        'Content-Type': 'application/json',
        clientId: clientId,
    };
    var previewRegExp = /(\.wip)|(\.app)/;
    var previewEnv = (previewRegExp.exec(oidcUrl) || [null])[0];
    if (previewEnv) {
        return __assign$1(__assign$1({}, headers), { previewType: previewEnv === '.wip' ? 'WIP' : 'APR' });
    }
    return headers;
};
var updateBag = function (_a) {
    var brand = _a.brand, clientId = _a.clientId, items = _a.items, locale = _a.locale, market = _a.market, name = _a.name, oidcUrl = _a.oidcUrl, shoppingBagId = _a.shoppingBagId;
    return __awaiter(void 0, void 0, void 0, function () {
        var url, _b, sku, quantity, data, translations, headers;
        return __generator(this, function (_c) {
            url = !shoppingBagId
                ? "" + oidcUrl + LEAP_FROG_ADD_TO_BAG_URL + "items/summary?locale=" + locale
                : "" + oidcUrl + LEAP_FROG_ADD_TO_BAG_URL + shoppingBagId + "/items/summary?locale=" + locale;
            _b = items[0], sku = _b.sku, quantity = _b.quantity;
            data = {
                market: market,
                brand: brand,
                partialReservation: true,
                items: items,
            };
            translations = getTranslations(locale);
            headers = requestHeader({
                brand: brand,
                clientId: clientId,
                market: market,
                oidcUrl: oidcUrl,
            });
            return [2 /*return*/, fetch(url, {
                    method: 'POST',
                    credentials: 'include',
                    headers: headers,
                    body: JSON.stringify(data),
                })
                    .then(catchHttpError)
                    .then(function (response) { return response.json(); })
                    .then(function (response) {
                    var _a;
                    var _b = response.items, _c = _b === void 0 ? [{}] : _b, maxQuantityAllowed = _c[0].maxQuantityAllowed, _d = response.itemErrors, _e = _d === void 0 ? [
                        {
                            errorCode: null,
                        },
                    ] : _d, errorCode = _e[0].errorCode, _f = response.outOfStockItems, outOfStockItems = _f === void 0 ? [] : _f;
                    var mainError = response.errorCode;
                    /**
                     * In some cases, when there is a promotion added to certain products, multiple line items can be present
                     * In those scenarios, total of addedQuantity in individual line item reflects the total added quantity.
                     */
                    var addedQuantity = (_a = response.items) === null || _a === void 0 ? void 0 : _a.reduce(function (sum, item) {
                        return sum + item.addedQuantity;
                    }, 0);
                    var completeSuccess = !mainError && !errorCode && !outOfStockItems.length;
                    var partialSuccess = errorCode === PARTIAL_SUCCESS_ERR;
                    // if add to bag is at least partial success, then process the response data
                    if ((completeSuccess || partialSuccess) && response.productData) {
                        var actualQuantity = completeSuccess ? quantity : addedQuantity;
                        var warnings = completeSuccess
                            ? null
                            : {
                                errorCode: errorCode,
                                partialSuccess: true,
                                addedQuantity: addedQuantity,
                                message: translations({ errorCode: errorCode || mainError, quantityAdded: addedQuantity }),
                            };
                        var formattedResponse = leapfrogResponseFormatter({ locale: locale, response: response, actualQuantity: actualQuantity, sku: sku });
                        return __assign$1(__assign$1({}, formattedResponse), { warnings: warnings });
                    }
                    var decodedName = he.decode(name);
                    var moreInfo = errorCode === MAX_QUANTITY_LIMIT_ERR
                        ? translations({
                            errorCode: errorCode,
                            maxQuantityAllowed: maxQuantityAllowed,
                            name: decodedName,
                        })
                        : translations({ errorCode: errorCode || mainError });
                    return {
                        status: 'ERROR',
                        errors: [
                            {
                                errorCode: errorCode || mainError,
                                moreInfo: moreInfo,
                            },
                        ],
                    };
                })
                    .catch(function (err) {
                    var _a, _b, _c, _d;
                    var errorCode = ((_b = (_a = err === null || err === void 0 ? void 0 : err.itemErrors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.errorCode) || (err === null || err === void 0 ? void 0 : err.errorCode) || (err === null || err === void 0 ? void 0 : err.status) || err;
                    // Special scenario where leapfrog service returns error code as partial success
                    // when ICM returns OOS and we have to treat it as regular out of stock scenario
                    if (errorCode === PARTIAL_SUCCESS_ERR) {
                        errorCode = OUT_OF_STOCK_ERR;
                    }
                    if (errorCode === MAX_QUANTITY_LIMIT_ERR) {
                        var decodedName = he.decode(name);
                        var maxQuantityAllowed = (_d = (_c = err === null || err === void 0 ? void 0 : err.itemErrors) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.maxQuantityAllowed;
                        var moreInfo = translations({
                            errorCode: errorCode,
                            maxQuantityAllowed: maxQuantityAllowed,
                            name: decodedName,
                        });
                        return {
                            status: 'ERROR',
                            errors: [
                                {
                                    errorCode: errorCode,
                                    moreInfo: moreInfo,
                                },
                            ],
                        };
                    }
                    return {
                        status: 'ERROR',
                        errors: [
                            {
                                errorCode: errorCode || DEFAULT_BAG_ERROR,
                                moreInfo: translations({ errorCode: errorCode }),
                                developerMessage: "Add to Bag - " + ((err === null || err === void 0 ? void 0 : err.userMessage) || (err && typeof err === 'object' && JSON.stringify(err)) || err),
                            },
                        ],
                    };
                })];
        });
    });
};

var defaultConfig = {
    credentials: 'include',
};
function addToBag(_a) {
    var brand = _a.brand, clientId = _a.clientId, items = _a.items, locale = _a.locale, market = _a.market, name = _a.name, oidcUrl = _a.oidcUrl, shoppingBagId = _a.shoppingBagId;
    return __awaiter(this, void 0, void 0, function () {
        var brandCode, marketCode, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    brandCode = addToBagBrandCodes[brand];
                    marketCode = market.toUpperCase();
                    return [4 /*yield*/, updateBag({
                            brand: brandCode,
                            clientId: clientId,
                            items: items,
                            locale: locale,
                            market: marketCode,
                            name: name,
                            oidcUrl: oidcUrl,
                            shoppingBagId: shoppingBagId,
                        })];
                case 1:
                    data = _b.sent();
                    return [2 /*return*/, data];
            }
        });
    });
}
/**
 * Legacy Add to Bag Service
 * @param baseUrl
 * @param queryString must have skuId quantity, sfl and cid
 */
function addToBagLegacyRequest(_a) {
    var baseUrl = _a.baseUrl, queryString = _a.queryString;
    var url = baseUrl + "/buy/inlineShoppingBagAddJson.do" + queryString;
    return fetch(url, defaultConfig)
        .then(catchHttpError)
        .then(function (response) { return response.json(); })
        .then(normalizeLegacyResponse)
        .catch(function (err) {
        return {
            status: 'ERROR',
            errors: [
                {
                    moreInfo: err.message || 'Network Error',
                    errorCode: err.message,
                },
            ],
        };
    });
}

dayjs.extend(utc);
dayjs.extend(duration);
/**
 * @param inventoryStatusId a number corresponding to a specific inventory status
 * @return an object with the prop backorder_cart_add: true when back ordered or
 * an empty object
 */
var getBackOrderProp = function (inventoryStatusId) {
    var isBackOrdered = inventoryStatusId === 4;
    return isBackOrdered ? { backorder_cart_add: true } : {};
};
/**
 * @param backOrderDate an ISO formatted date string
 * @param today a Date object representing the current date and time
 * @return a formatted back order status or empty string
 */
function getBackOrderStatus(backOrderDate, today) {
    if (backOrderDate) {
        var duration_1 = dayjs.utc(backOrderDate).diff(today);
        var weeks = Math.round(dayjs.duration(duration_1).asWeeks());
        var status_1 = weeks > 1 ? weeks + " weeks" : '1 week';
        return "Back Ordered [" + status_1 + "]";
    }
    return '';
}
/**
 * @param inventoryStatusId a number corresonding to inventory status or null
 * 0 - "In Stock"
 * 1 - "Low Stock"
 * 4 - "Back Ordered"
 * @param backOrderDate an ISO formatted date string
 * @return a product inventory status or null
 */
function getProductInventoryStatus(inventoryStatusId, backOrderDate) {
    var backOrderStatus = getBackOrderStatus(backOrderDate, new Date());
    var productInventoryStatus = {
        0: 'In Stock',
        1: 'Low Stock',
        4: backOrderStatus,
    }[inventoryStatusId];
    return productInventoryStatus || null;
}

var priceFormat = /[\d|,]+\.*[\d|,]*/;
var stripEventFormat = /event\d+=/;
var toNumeric = function (str) {
    return parseFloat(((str.replace(stripEventFormat, '').match(priceFormat) || [])[0] || '0.00').replace(',', ''));
};
var extractPrice = function (str) {
    if (!str) {
        return '';
    }
    return toNumeric(str).toFixed(2);
};
var addToBagReportingDataBuilder = function (_a) {
    var _b = _a.name, name = _b === void 0 ? '' : _b, price = _a.price, _c = _a.quantity, quantity = _c === void 0 ? 1 : _c, _d = _a.sku, sku = _d === void 0 ? '' : _d, _e = _a.itemSubtotal, itemSubtotal = _e === void 0 ? '' : _e, _f = _a.pid, pid = _f === void 0 ? '' : _f, _g = _a.selectedSize, selectedSize = _g === void 0 ? '' : _g, inventoryStatusId = _a.inventoryStatusId, backOrderDate = _a.backOrderDate;
    var _h = price.rawRegularPrice, listPrice = _h === void 0 ? 0 : _h, _j = price.rawCurrentPrice, soldPrice = _j === void 0 ? 0 : _j, _k = price.localizedCurrentPrice, localizedPrice = _k === void 0 ? '' : _k;
    var markDownAmount = ((listPrice - soldPrice) * quantity).toFixed(2);
    var productGrossMerchandise = extractPrice(itemSubtotal);
    var productInventoryConversion = getProductInventoryStatus(inventoryStatusId, backOrderDate);
    var backOrderProp = getBackOrderProp(inventoryStatusId);
    return __assign$1({ product_gross_merchandise: [productGrossMerchandise], product_id: [pid.slice(0, 6)], product_markdown_amount: [markDownAmount], product_name: [name], product_price: ["" + localizedPrice], product_quantity: ["" + quantity], product_sku: [sku], product_selected_size: [selectedSize], product_inventory_conversion: productInventoryConversion }, backOrderProp);
};

var AddToBagButton = function (_a) {
    var onClick = _a.onClick, styles = _a.styles, children = _a.children, otherProps = __rest$1(_a, ["onClick", "styles", "children"]);
    return (jsx(ComposableButton, __assign$1({}, otherProps, { css: styles, onClick: onClick }), children));
};

var getButtonAnimationStatus = function (inProgress, response) {
    var _a, _b;
    if (inProgress) {
        return AnimationStatus.Loading;
    }
    if ((response === null || response === void 0 ? void 0 : response.status) === 'SUCCESS' && !((_a = response === null || response === void 0 ? void 0 : response.errors) === null || _a === void 0 ? void 0 : _a.length)) {
        return AnimationStatus.Success;
    }
    if ((response === null || response === void 0 ? void 0 : response.status) === 'ERROR' || (response === null || response === void 0 ? void 0 : response.status) === 'FAILURE' || ((_b = response === null || response === void 0 ? void 0 : response.errors) === null || _b === void 0 ? void 0 : _b.length)) {
        return AnimationStatus.Failure;
    }
    return AnimationStatus.None;
};

var getButtonLabel = function (selectedSku, inProgress, buttonLabels) {
    if (selectedSku && inProgress) {
        return '';
    }
    if (selectedSku) {
        return buttonLabels.addItemToBag;
    }
    if (!selectedSku) {
        return buttonLabels.selectASize;
    }
    return '';
};

var errorStyles = function (theme) { return css(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  ", "\n  border: 0;\n  border-style: none;\n  flex: none;\n"], ["\n  ", "\n  border: 0;\n  border-style: none;\n  flex: none;\n"])), errorMessageStyles(theme)); };
var baseStyles = function () { return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 36px;\n\n  svg {\n    height: 14px;\n    width: 14px;\n    margin-top: 0.18rem;\n    margin-left: 0.23rem;\n  }\n"], ["\n  height: 36px;\n\n  svg {\n    height: 14px;\n    width: 14px;\n    margin-top: 0.18rem;\n    margin-left: 0.23rem;\n  }\n"]))); };
var templateObject_1$2, templateObject_2;

var addToBagStyles = function (theme, isNewBrFontEnabled, isQuickAddRedesignEnabled, inProgress) {
    var fontColor = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? theme.color.inverse.b1 : theme.color.wh,
        brfs: isQuickAddRedesignEnabled ? theme.color.inverse.b1 : theme.color.wh,
        default: theme.color.wh,
    });
    var fontSize = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? '1rem' : '0.875rem',
        brfs: isQuickAddRedesignEnabled ? '1rem' : '0.875rem',
        default: function () { return '0.875rem'; },
    });
    var fontWeight = forBrands(theme, {
        at: function () { return 600; },
        br: function () { return (isNewBrFontEnabled ? 600 : 700); },
        brfs: function () { return (isNewBrFontEnabled ? 600 : 700); },
        default: function () { return "" + getFontWeight('bold').fontWeight; },
    });
    var redesignFontWeight = forBrands(theme, {
        br: function () { return "" + getFontWeight('regular').fontWeight; },
        brfs: function () { return "" + getFontWeight('regular').fontWeight; },
        default: function () { return "" + getFontWeight('bold').fontWeight; },
    });
    var letterSpacing = forBrands(theme, {
        default: '0.5px',
    });
    var textTransform = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? 'none' : 'uppercase',
        brfs: isQuickAddRedesignEnabled ? 'none' : 'uppercase',
        default: 'uppercase',
    });
    var enabledBackgroundColor = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? theme.color.b2 : theme.color.b1,
        brfs: isQuickAddRedesignEnabled ? theme.color.b2 : theme.color.b1,
        default: theme.color.b1,
    });
    var disabledBackgroundColor = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? theme.color.inverse.b1 : theme.color.wh,
        brfs: isQuickAddRedesignEnabled ? theme.color.inverse.b1 : theme.color.wh,
        default: theme.color.wh,
    });
    var disabledFontColor = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? theme.color.b2 : theme.color.gray54,
        brfs: isQuickAddRedesignEnabled ? theme.color.b2 : theme.color.gray54,
        default: theme.color.gray54,
    });
    var disabledBorderColor = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? theme.color.b2 : theme.color.gray54,
        brfs: isQuickAddRedesignEnabled ? theme.color.b2 : theme.color.gray54,
        default: theme.color.gray54,
    });
    var disabledFontWeight = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? "" + getFontWeight('regular').fontWeight : '',
        brfs: isQuickAddRedesignEnabled ? "" + getFontWeight('regular').fontWeight : '',
        default: '',
    });
    var paddingLeftSuccessMessage = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? 'padding-left: 0.8125rem' : '',
        brfs: isQuickAddRedesignEnabled ? 'padding-left: 0.8125rem' : '',
        default: '',
    });
    return css(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n    ", "\n    margin-top: 1rem;\n    background-color: ", ";\n    color: ", ";\n    ", "\n    font-size: ", " !important;\n    font-weight: ", ";\n    letter-spacing: ", ";\n    text-transform: ", ";\n\n    &.add-to-bag--disabled {\n      background-color: ", ";\n      color: ", ";\n      border-color: ", ";\n      font-weight: ", ";\n    }\n\n    &.quick-add.add-to-bag > div > div {\n      ", ";\n    }\n\n    &.focus-visible {\n      outline: 0;\n      box-shadow: 0 0 0 3px ", ";\n    }\n  "], ["\n    ", "\n    margin-top: 1rem;\n    background-color: ", ";\n    color: ", ";\n    ", "\n    font-size: ", " !important;\n    font-weight: ", ";\n    letter-spacing: ", ";\n    text-transform: ", ";\n\n    &.add-to-bag--disabled {\n      background-color: ", ";\n      color: ", ";\n      border-color: ", ";\n      font-weight: ", ";\n    }\n\n    &.quick-add.add-to-bag > div > div {\n      ", ";\n    }\n\n    &.focus-visible {\n      outline: 0;\n      box-shadow: 0 0 0 3px ", ";\n    }\n  "])), baseStyles(), enabledBackgroundColor, fontColor, theme.font.primary, fontSize, isQuickAddRedesignEnabled ? redesignFontWeight : fontWeight, letterSpacing, textTransform, disabledBackgroundColor, disabledFontColor, disabledBorderColor, disabledFontWeight, inProgress ? '' : paddingLeftSuccessMessage, theme.crossBrand.color.b2);
};
var addToBagWrapperStyles = function (theme, isQuickAddRedesignEnabled) {
    var errorMessageStyles = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? theme.color.b2 : theme.color.bk,
        brfs: isQuickAddRedesignEnabled ? theme.color.b2 : theme.color.bk,
        default: theme.color.bk,
    });
    return css(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n    .quick-add-error-message {\n      color: ", " !important;\n    }\n  "], ["\n    .quick-add-error-message {\n      color: ", " !important;\n    }\n  "])), errorMessageStyles);
};
var templateObject_1$3, templateObject_2$1;

var addToBagButtonStyles = function (theme, isNewBrFontEnabled, isQuickAddRedesignEnabled, inProgress) {
    var brFontWeightStyles = forBrands(theme, {
        br: function () { return (isNewBrFontEnabled ? 'font-weight: 400' : ''); },
        brfs: function () { return (isNewBrFontEnabled ? 'font-weight: 400' : ''); },
    });
    var brBorderRadiusStyles = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? '0px' : '4px',
        brfs: isQuickAddRedesignEnabled ? '0px' : '4px',
        default: '4px',
    });
    return css(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n    ", "\n    width: 100%;\n    height: 3.313rem;\n    font-size: 0.875rem;\n    border-width: 1px;\n    border-radius: ", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &.add-to-bag--disabled {\n      .regular-price::before {\n        color: ", ";\n      }\n    }\n\n    .regular-price {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n\n      span {\n        ", ";\n      }\n    }\n\n    .regular-price__pipe {\n      padding-left: 1.5rem;\n      padding-right: 1.5rem;\n    }\n\n    .regular-price__line-through::before {\n      padding-right: 1.25rem;\n    }\n\n    .regular-price__line-through {\n      font-weight: 400;\n      text-decoration-line: line-through;\n    }\n\n    @media (max-width: 693px) {\n      width: 100%;\n    }\n  "], ["\n    ", "\n    width: 100%;\n    height: 3.313rem;\n    font-size: 0.875rem;\n    border-width: 1px;\n    border-radius: ", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &.add-to-bag--disabled {\n      .regular-price::before {\n        color: ", ";\n      }\n    }\n\n    .regular-price {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n\n      span {\n        ", ";\n      }\n    }\n\n    .regular-price__pipe {\n      padding-left: 1.5rem;\n      padding-right: 1.5rem;\n    }\n\n    .regular-price__line-through::before {\n      padding-right: 1.25rem;\n    }\n\n    .regular-price__line-through {\n      font-weight: 400;\n      text-decoration-line: line-through;\n    }\n\n    @media (max-width: 693px) {\n      width: 100%;\n    }\n  "])), addToBagStyles(theme, isNewBrFontEnabled, isQuickAddRedesignEnabled, inProgress), brBorderRadiusStyles, theme.color.gray54, brFontWeightStyles);
};
var templateObject_1$4;

var getButtonLabelLocalization = function (localize) { return ({
    selectASize: localize('quickAdd.selectASize'),
    addItemToBag: localize('quickAdd.addToBag'),
    addToBagInProgress: '',
    addToBagSuccess: localize('quickAdd.addToBagSuccess'),
    addToBagFailure: localize('quickAdd.addToBagFailure'),
}); };

function PriceLabel(_a) {
    var price = _a.price;
    var localize = useLocalize().localize;
    var currentPrice = price.rawCurrentPrice, regularPrice = price.rawRegularPrice;
    var isSalePrice = currentPrice < regularPrice;
    var isCurrentPriceHigherThanRegular = currentPrice > regularPrice;
    var getAriaLabel = function () {
        return isSalePrice ? localize('pdp.price.regularPriceAriaLabel', { price: price.localizedRegularPrice }) : '';
    };
    var priceCrossedClassNames = classnames({
        'regular-price__line-through': isSalePrice,
    });
    return (React.createElement(Fragment, null,
        React.createElement("span", { className: "regular-price__pipe" }, "|"),
        React.createElement("div", { "aria-label": getAriaLabel(), className: "regular-price" },
            isSalePrice && React.createElement("span", null, price.localizedCurrentPrice),
            React.createElement("span", { className: priceCrossedClassNames }, isCurrentPriceHigherThanRegular ? price.localizedCurrentPrice : price.localizedRegularPrice))));
}

var isBananaRepublic = function (brand) {
    var brands = [Brands.BananaRepublic, Brands.BananaRepublicFactoryStore];
    return brands.join(',').includes(brand.toLowerCase());
};

var RenderActionButton = function (_a) {
    var brandName = _a.brandName, inProgress = _a.inProgress, response = _a.response, onButtonClick = _a.onButtonClick, htmlProps = _a.htmlProps, selectedSku = _a.selectedSku, price = _a.price, isGiftCard = _a.isGiftCard, isQuickAddRedesignEnabled = _a.isQuickAddRedesignEnabled;
    var enabledFeatures = useContext(FeatureFlagsContext).enabledFeatures;
    var brFontFeatureFlag = isBananaRepublic(brandName) ? 'enable-new-br-fonts' : '';
    var brFontEnabled = enabledFeatures[brFontFeatureFlag];
    var localize = useLocalize().localize;
    var buttonLabels = getButtonLabelLocalization(localize);
    var successMessage = buttonLabels.addToBagSuccess;
    var failureMessage = buttonLabels.addToBagFailure;
    var addToBagClasses = classnames('quick-add add-to-bag', {
        'add-to-bag--disabled': !selectedSku,
    });
    return (React.createElement(AddToBagButton, __assign({ animationStatus: getButtonAnimationStatus(inProgress, response), capitalization: Capitalization.uppercase, className: "" + addToBagClasses, failureMessage: failureMessage, fullWidth: true, isQuickAddRedesignEnabled: isQuickAddRedesignEnabled, onClick: onButtonClick, roundedCorners: true, styles: function (theme) { return addToBagButtonStyles(theme, brFontEnabled, isQuickAddRedesignEnabled, inProgress); }, successMessage: successMessage }, htmlProps),
        React.createElement("span", null, getButtonLabel(selectedSku, inProgress, buttonLabels)),
        selectedSku && !isGiftCard && React.createElement(PriceLabel, { price: price })));
};

/** @jsx jsx */
var ErrorMessage = function (_a) {
    var error = _a.error;
    var hasError = useCallback(function () {
        return error && error !== '';
    }, [error]);
    return (jsx(React.Fragment, null, hasError() && (jsx("div", { "aria-live": "polite", className: "quick-add-error-message", css: errorStyles, role: "alert" }, error))));
};

var AddToBagErrors = function (_a) {
    var response = _a.response, clientId = _a.clientId, errorLogger = _a.errorLogger;
    var errors = response === null || response === void 0 ? void 0 : response.errors;
    return (React.createElement(React.Fragment, null, errors === null || errors === void 0 ? void 0 : errors.map(function (err, i) {
        errorLogger(new Error("[ERROR] " + clientId + " QuickAdd Error message: " + err.moreInfo + " "));
        return ((err.developerMessage || err.moreInfo) && (React.createElement(ErrorMessage, { key: "add-to-bag-error-" + i.toString(), error: err.moreInfo || '' })));
    })));
};

var SelectSizeError = function (_a) {
    var showError = _a.showError, unselectedDimensions = _a.unselectedDimensions;
    var localize = useLocalize().localize;
    var hasError = useCallback(function () {
        return showError && unselectedDimensions && unselectedDimensions !== '';
    }, [showError, unselectedDimensions]);
    return (React.createElement(React.Fragment, null, hasError() && React.createElement(ErrorMessage, { error: localize('quickAdd.error.sizeSelection', { unselectedDimensions: unselectedDimensions }) })));
};

var getRequestInfo = function (_a) {
    var addToBagUrls = _a.addToBagUrls, brand = _a.brand, _b = _a.clientId, clientId = _b === void 0 ? 'QuickAdd' : _b, enableLegacyAddToBag = _a.enableLegacyAddToBag, locale = _a.locale, market = _a.market, name = _a.name, selectedSku = _a.selectedSku, unknownShopperId = _a.unknownShopperId;
    var _c = selectedSku || {}, skuId = _c.skuId, _d = _c.quantity, quantity = _d === void 0 ? '1' : _d;
    var legacyUrl = addToBagUrls.secureUrl, oidcUrl = addToBagUrls.oidcUrl;
    if (enableLegacyAddToBag) {
        var queryString = legacyRequestBuilder({ skuId: skuId, quantity: quantity });
        return { request: addToBagLegacyRequest({ baseUrl: legacyUrl, queryString: queryString }) };
    }
    var item = leapfrogRequestBuilder({ skuId: skuId, quantity: parseInt(quantity, 10) || 1 });
    return {
        request: addToBag({
            brand: brand,
            clientId: clientId,
            items: [__assign({}, item)],
            locale: locale,
            market: market,
            name: name,
            oidcUrl: oidcUrl,
            shoppingBagId: unknownShopperId,
        }),
    };
};

var updateBagCount = function (selectedSku, currentBagItemCount) {
    var itemsToAdd = parseInt(selectedSku.quantity, 10) || 1;
    var updateBagEvent = new CustomEvent('updateBagCount', {
        detail: {
            quantity: (currentBagItemCount || 0) + itemsToAdd,
        },
    });
    document.dispatchEvent(updateBagEvent);
};

function updateBagCountOnSuccess(processedResponse, selectedSku, shoppingBag) {
    var _a;
    var isSuccess = (processedResponse === null || processedResponse === void 0 ? void 0 : processedResponse.status) === 'SUCCESS' && !((_a = processedResponse === null || processedResponse === void 0 ? void 0 : processedResponse.errors) === null || _a === void 0 ? void 0 : _a.length);
    isSuccess && updateBagCount(selectedSku, shoppingBag === null || shoppingBag === void 0 ? void 0 : shoppingBag.totalItemCount);
}
function buildAddToBagReporting(processedResponse, selectedDimensions, selectedSku, price, name, pid, quantity) {
    var itemSubtotal = extractItemSubtotal(processedResponse.itemSubtotal);
    var selectedSize = extractSelectedSize(selectedDimensions);
    return addToBagReportingDataBuilder({
        sku: selectedSku.skuId,
        price: price,
        name: name,
        pid: pid,
        itemSubtotal: itemSubtotal,
        selectedSize: selectedSize,
        quantity: parseInt(quantity, 10),
        inventoryStatusId: selectedSku.inventoryStatusId,
        backOrderDate: selectedSku.backOrderDate,
    });
}
function extractItemSubtotal(itemSubtotal) {
    return itemSubtotal || '';
}
function extractSelectedSize(selectedDimensions) {
    return selectedDimensions ? Object.values(selectedDimensions).join(' ') : '';
}
function handleAddToBagResponse(_a) {
    var request = _a.request, selectedDimensions = _a.selectedDimensions, selectedSku = _a.selectedSku, price = _a.price, name = _a.name, pid = _a.pid, quantity = _a.quantity, onAddToBag = _a.onAddToBag, shoppingBag = _a.shoppingBag, dispatch = _a.dispatch;
    request.then(function (processedResponse) {
        updateBagCountOnSuccess(processedResponse, selectedSku, shoppingBag);
        var reportingData = buildAddToBagReporting(processedResponse, selectedDimensions, selectedSku, price, name, pid, quantity);
        onAddToBag === null || onAddToBag === void 0 ? void 0 : onAddToBag(processedResponse, reportingData);
        dispatch({
            type: ADD_TO_BAG_RESPONSE,
            payload: {
                response: processedResponse,
            },
        });
    });
}

function handleButtonClick(_a) {
    var enableLegacyAddToBag = _a.enableLegacyAddToBag, unknownShopperId = _a.unknownShopperId, disableShoppingBagId = _a.disableShoppingBagId, response = _a.response, selectedSku = _a.selectedSku, setShowError = _a.setShowError, dispatch = _a.dispatch, addToBagUrls = _a.addToBagUrls, brandName = _a.brandName, clientId = _a.clientId, locale = _a.locale, market = _a.market, name = _a.name, selectedDimensions = _a.selectedDimensions, price = _a.price, pid = _a.pid, onAddToBag = _a.onAddToBag, shoppingBag = _a.shoppingBag;
    return function () {
        if (checkErrors(enableLegacyAddToBag, unknownShopperId, disableShoppingBagId, response)) {
            return;
        }
        if (!selectedSku) {
            setShowError(true);
            dispatch({ type: ADD_TO_BAG_SIZE_VALIDATION });
            return;
        }
        setShowError(false);
        dispatch({ type: ADD_TO_BAG_REQUEST });
        var request = getRequestInfo({
            addToBagUrls: addToBagUrls,
            brand: brandName,
            clientId: clientId,
            enableLegacyAddToBag: enableLegacyAddToBag,
            locale: locale,
            market: market,
            name: name,
            selectedSku: selectedSku,
            unknownShopperId: disableShoppingBagId ? null : unknownShopperId,
        }).request;
        var _a = (selectedSku || {}).quantity, quantity = _a === void 0 ? '1' : _a;
        handleAddToBagResponse({
            request: request,
            selectedDimensions: selectedDimensions,
            selectedSku: selectedSku,
            price: price,
            name: name,
            pid: pid,
            quantity: quantity,
            onAddToBag: onAddToBag,
            shoppingBag: shoppingBag,
            dispatch: dispatch,
        });
    };
}
function checkErrors(enableLegacyAddToBag, unknownShopperId, disableShoppingBagId, response) {
    var _a;
    return (!enableLegacyAddToBag && !unknownShopperId && !disableShoppingBagId) || ((_a = response === null || response === void 0 ? void 0 : response.errors) === null || _a === void 0 ? void 0 : _a.length);
}

function AddToBag(_a) {
    var addToBagUrls = _a.addToBagUrls, brandName = _a.brandName, clientId = _a.clientId, dispatch = _a.dispatch, enableLegacyAddToBag = _a.enableLegacyAddToBag, inProgress = _a.inProgress, name = _a.name, onAddToBag = _a.onAddToBag, price = _a.price, pid = _a.pid, response = _a.response, selectedSku = _a.selectedSku, _b = _a.selectedDimensions, selectedDimensions = _b === void 0 ? {} : _b, unselectedDimensions = _a.unselectedDimensions, errorLogger = _a.errorLogger, isGiftCard = _a.isGiftCard, isQuickAddRedesignEnabled = _a.isQuickAddRedesignEnabled, htmlProps = __rest(_a, ["addToBagUrls", "brandName", "clientId", "dispatch", "enableLegacyAddToBag", "inProgress", "name", "onAddToBag", "price", "pid", "response", "selectedSku", "selectedDimensions", "unselectedDimensions", "errorLogger", "isGiftCard", "isQuickAddRedesignEnabled"]);
    var _c = useState(false), showError = _c[0], setShowError = _c[1];
    var enabledFeatures = useContext(FeatureFlagsContext).enabledFeatures;
    var _d = useAppState$1(), market = _d.market, locale = _d.locale;
    var _e = useContext(PersonalizationContext) || {}, unknownShopperId = _e.customerUUID, shoppingBag = _e.shoppingBag;
    var disableShoppingBagId = enabledFeatures['pdp-leapfrog-remove-shoppingBagId'];
    var onButtonClick = handleButtonClick({
        enableLegacyAddToBag: enableLegacyAddToBag,
        unknownShopperId: unknownShopperId,
        disableShoppingBagId: disableShoppingBagId,
        response: response,
        selectedSku: selectedSku,
        setShowError: setShowError,
        dispatch: dispatch,
        addToBagUrls: addToBagUrls,
        brandName: brandName,
        clientId: clientId,
        locale: locale,
        market: market,
        name: name,
        selectedDimensions: selectedDimensions,
        price: price,
        pid: pid,
        onAddToBag: onAddToBag,
        shoppingBag: shoppingBag,
    });
    return (jsx("div", { css: function (theme) { return addToBagWrapperStyles(theme, isQuickAddRedesignEnabled); } },
        jsx(SelectSizeError, { showError: showError, unselectedDimensions: unselectedDimensions }),
        jsx(AddToBagErrors, { clientId: clientId, errorLogger: errorLogger, response: response }),
        jsx(BackOrderMessage, { isQuickAddRedesignEnabled: isQuickAddRedesignEnabled, selectedSku: selectedSku }),
        jsx(RenderActionButton, { brandName: brandName, htmlProps: htmlProps, inProgress: inProgress, isGiftCard: isGiftCard, isQuickAddRedesignEnabled: isQuickAddRedesignEnabled, onButtonClick: onButtonClick, price: price, response: response, selectedSku: selectedSku })));
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$2 = function() {
    __assign$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};

function __makeTemplateObject$1(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var visuallyHide$1 = function () {
    return css(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject$1(["\n    position: absolute;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n  "], ["\n    position: absolute;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n  "])));
};
var templateObject_7$1;

function backorderMessageStyles(theme) {
    return css(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject$1(["\n    ", "\n    text-align: left;\n    top: 0;\n    left: 0;\n    transform: translate(0, calc(-100% - 0.75rem));\n    font-size: 0.75rem;\n    color: ", ";\n    z-index: 10;\n    text-transform: none;\n    background-color: ", ";\n    box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.15);\n    border-radius: 0.25rem;\n    padding: 0.5rem;\n    line-height: 1.5;\n    white-space: normal;\n\n    .dimensions-group & {\n      letter-spacing: normal;\n    }\n\n    &.backorder-color--show {\n      transform: translate(0, calc(-100% + 1.75rem));\n    }\n\n    .swatch--dimension:hover &,\n    .pdp-dimension:hover &,\n    .swatch--dimension .swatch__radio.focus-visible ~ &,\n    .pdp-dimension .pdp-dimension__radio.focus-visible ~ &,\n    &.backorder-color--show {\n      @media (min-width: 768px) {\n        height: auto;\n        width: 9.375rem;\n        overflow: visible;\n        clip: initial;\n      }\n    }\n  "], ["\n    ", "\n    text-align: left;\n    top: 0;\n    left: 0;\n    transform: translate(0, calc(-100% - 0.75rem));\n    font-size: 0.75rem;\n    color: ", ";\n    z-index: 10;\n    text-transform: none;\n    background-color: ", ";\n    box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.15);\n    border-radius: 0.25rem;\n    padding: 0.5rem;\n    line-height: 1.5;\n    white-space: normal;\n\n    .dimensions-group & {\n      letter-spacing: normal;\n    }\n\n    &.backorder-color--show {\n      transform: translate(0, calc(-100% + 1.75rem));\n    }\n\n    .swatch--dimension:hover &,\n    .pdp-dimension:hover &,\n    .swatch--dimension .swatch__radio.focus-visible ~ &,\n    .pdp-dimension .pdp-dimension__radio.focus-visible ~ &,\n    &.backorder-color--show {\n      @media (min-width: 768px) {\n        height: auto;\n        width: 9.375rem;\n        overflow: visible;\n        clip: initial;\n      }\n    }\n  "])), visuallyHide$1(), theme.color.g1, theme.color.wh);
}
var templateObject_1$5;

var removeAriaExpandedFromObject = function (triggerProps) {
    var newTriggerProps = triggerProps;
    if (newTriggerProps) {
        var hasAriaExpanded = Object.prototype.hasOwnProperty.call(newTriggerProps, 'aria-expanded');
        if (hasAriaExpanded) {
            delete newTriggerProps['aria-expanded'];
        }
    }
    return newTriggerProps;
};
function DimensionRadio(_a) {
    var backOrderMessage = _a.backOrderMessage, id = _a.id, _b = _a.inStock, inStock = _b === void 0 ? true : _b, name = _a.name, value = _a.value, onBlur = _a.onBlur, onChange = _a.onChange, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, _c = _a.selected, selected = _c === void 0 ? false : _c, _d = _a.shouldDisplayInStock, shouldDisplayInStock = _d === void 0 ? true : _d, visibleBackOrderTooltip = _a.visibleBackOrderTooltip, className = _a.className, triggerProps = _a.triggerProps;
    var localize = useLocalize().localize;
    var isLong = value.length > 3;
    var dimensionClasses = classnames('pdp-dimension', {
        selected: selected,
        'pdp-dimension--unavailable': !inStock,
        'pdp-dimension--auto-width': isLong,
        'pdp-dimension--should-display-redesign-in-stock': shouldDisplayInStock,
    });
    var newTriggerProps = removeAriaExpandedFromObject(triggerProps);
    return (jsx("div", { className: className + " " + dimensionClasses, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        jsx("input", __assign$2({ "aria-disabled": !inStock ? 'true' : 'false', "aria-label": !inStock ? localize('dimensionRadio.outOfStock', { dimension: value }) : value, checked: selected, className: "pdp-dimension__radio", id: id, name: name, onBlur: onBlur, onChange: onChange, type: "radio", value: value }, newTriggerProps)),
        jsx("span", { "aria-hidden": true, className: "pdp-dimension__label" },
            jsx("span", { className: "pdp-dimension__text" }, value)),
        shouldDisplayInStock && jsx(DimensionStockIndicator, { inStock: inStock }),
        backOrderMessage && visibleBackOrderTooltip && (jsx("span", { "aria-hidden": "true", className: "backorder-message", css: backorderMessageStyles, "data-testid": "dimension-radio-backorder-message" }, backOrderMessage.mainText))));
}

var colorMap = {
    brLightColor2: '#F6F1EC',
    blackColor1: '#111111',
    blackColor2: '#2C2824',
    atGrayColor: '#757575',
    atGrayColor2: '#EFEFEF',
    brDarkGray: '#403C38',
    brLightColor4: '#E2E0D7',
    brGreyColor2: '#CECBC3',
    onBlueColor: '#004779',
    onBlueColor2: '#002554',
    onBlueColor3: '#0F3764',
    onBlueColor4: '#003764',
    onDarkColor: '#202020',
    onGrayColor: '#FAFAFA',
    onGrayColor2: '#EFEFEF',
    gapLinkColor: '#0A5694',
    gapDarkGray: '#666666',
    atLinkColor: '#2A71D4',
    grayColor3A: '#3A3A3A',
    whiteCreame: '#F6F4EB',
    darkBlue: '#000D42',
    grayD8: '#D8D9D6',
    black2A: '#2A2A2A',
    black2Balpha20: '#2B2B2B33',
    black2B: '#2B2B2B',
    brGrayColor3: '#2D2925',
    brDarkGray2: '#4D4D4D',
    grayColor2c28: '#2c282433',
};

var newRedesingForDimensionRadioStyles = function (theme, isQuickAddRedesignEnabled) {
    var brNewRedesignForDimensionRadio = "\n    margin: 0.375rem 0.625rem;\n\n    &.pdp-dimension--unavailable.pdp-dimension--should-display-redesign-in-stock {\n      & .pdp-dimension__text::before {\n        content: '';\n        position: absolute;\n        display: block;\n        width: 120%;\n        left: -10%;\n        border-top: 1px solid " + theme.color.wh + ";\n        bottom: 50%;\n      }\n\n      & > .swatch__out-of-stock-indicator {\n        display: none;\n      }\n    }\n\n  ";
    var onNewRedesinForDimensionRadio = "\n    borderRadius: '';\n    margin: 0.375rem 0.21875rem;\n    lineHeight: 1.063rem;\n\n    &.pdp-dimension--unavailable.pdp-dimension--should-display-redesign-in-stock {\n      & .pdp-dimension__text::before {\n        content: '';\n        position: absolute;\n        display: block;\n        width: 120%;\n        left: -10%;\n        border-top: 1px solid " + theme.blackColor1 + ";\n        bottom: 50%;\n      }\n\n      & > .swatch__out-of-stock-indicator {\n        display: none;\n      }\n    }\n  ";
    var atNewRedesignForDimensionRadio = "\n    border-radius: 0%;\n    line-height: 1.195rem;\n    font-weight: " + getFontWeight('regular').fontWeight + ";\n    letter-spacing: 0.75px;\n    margin-bottom: 6px;\n    margin-right: 6px;\n    \n    &.pdp-dimension--unavailable.pdp-dimension--should-display-redesign-in-stock.selected {\n      & .pdp-dimension__text::before {\n        content: '';\n        position: absolute;\n        display: block;\n        width: 120%;\n        left: -10%;\n        border-top: 1px solid white;\n        bottom: 45%;\n      }\n      \n      &:hover{\n        & .pdp-dimension__text::before {\n          content: '';\n          position: absolute;\n          display: block;\n          width: 120%;\n          left: -10%;\n          border-top: 1px solid black;\n          bottom: 45%;\n        }\n      }\n    \n      & > .swatch__out-of-stock-indicator {\n        display: none;\n      }\n    }\n\n    &.pdp-dimension--unavailable.pdp-dimension--should-display-redesign-in-stock {\n      & .pdp-dimension__text::before {\n        content: '';\n        position: absolute;\n        display: block;\n        width: 120%;\n        left: -10%;\n        border-top: 1px solid black;\n        bottom: 45%;\n      }\n    \n      & > .swatch__out-of-stock-indicator {\n        display: none;\n      }\n    }\n  ";
    var gapNewRedesignForDimensionRadio = "\n  borderRadius: '';\n  margin: 0.1875rem 0.21875rem;\n\n  &.pdp-dimension--unavailable.pdp-dimension--should-display-redesign-in-stock {\n    & .pdp-dimension__text::before {\n      content: '';\n      position: absolute;\n      display: block;\n      width: 120%;\n      left: -10%;\n      border-top: 1px solid black;\n      bottom: 50%;\n    }\n\n    & > .swatch__out-of-stock-indicator {\n      display: none;\n    }\n  }\n";
    var newRedesingForDimensionRadio = forBrands(theme, {
        br: brNewRedesignForDimensionRadio,
        brfs: brNewRedesignForDimensionRadio,
        at: atNewRedesignForDimensionRadio,
        on: onNewRedesinForDimensionRadio,
        gap: gapNewRedesignForDimensionRadio,
        gapfs: gapNewRedesignForDimensionRadio,
        default: { borderRadius: '2rem' },
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? newRedesingForDimensionRadio : { borderRadius: '2rem' };
};
var newRedesignUnavailableSelectedIndicator = function (theme, isQuickAddRedesignEnabled) {
    var brUnavailableSelectedIndicator = "transform: scale(1) rotate(48deg);";
    var atUnavailableSelectedIndicator = "transform: scale(0.7) rotate(43deg); line{stroke: #ffffff66};";
    var onUnavailableSelectedIndicator = "transform: scale(1) rotate(57deg); top: 3px; width: 26px; left:11px; line{stroke: " + colorMap.blackColor1 + "};";
    var newRedesignAvailableSelectedIndicatorStyles = forBrands(theme, {
        br: function () { return brUnavailableSelectedIndicator; },
        brfs: function () { return brUnavailableSelectedIndicator; },
        at: function () { return atUnavailableSelectedIndicator; },
        on: function () { return onUnavailableSelectedIndicator; },
        default: '',
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? newRedesignAvailableSelectedIndicatorStyles : '';
};
var newRedesignUnavailableSelectedOpacity = function (theme, isQuickAddRedesignEnabled) {
    var unavailableSelectedOpacity = "opacity: 1;";
    var unavailableSelectedOpacityStyle = forBrands(theme, {
        at: function () { return unavailableSelectedOpacity; },
        br: function () { return unavailableSelectedOpacity; },
        brfs: function () { return unavailableSelectedOpacity; },
        default: '',
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? unavailableSelectedOpacityStyle : '';
};
var newRedesignSelectedAfterWrapperStyles = function (theme, isQuickAddRedesignEnabled) {
    var oldAfterStyles = function (color) { return "background-color: " + color + "; height:0.25rem; bottom: -0.5rem;"; };
    var selectedAfterWrapperStylesOld = forBrands(theme, {
        gap: function () { return oldAfterStyles(theme.color.b1); },
        gapfs: function () { return oldAfterStyles(theme.color.b1); },
        at: function () { return oldAfterStyles(theme.color.g1); },
        br: function () { return oldAfterStyles(theme.color.g1); },
        brfs: function () { return oldAfterStyles(theme.color.g1); },
        on: function () { return oldAfterStyles(theme.color.g1); },
    });
    var selectedAfterWrapperBrStyles = "border-bottom: 1px solid " + theme.color.inverse.b1 + ";\n      border-top: 1px solid " + theme.color.inverse.b1 + ";\n      bottom: 0.1875rem;\n      background-color: " + theme.color.inverse.b1 + ";";
    var selectedAfterWrapperStylesForBrands = forBrands(theme, {
        br: function () { return selectedAfterWrapperBrStyles; },
        brfs: function () { return selectedAfterWrapperBrStyles; },
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled
        ? selectedAfterWrapperStylesForBrands
        : selectedAfterWrapperStylesOld;
};
var newRedesignTextColor = function (theme, isQuickAddRedesignEnabled) {
    var brTextColor = theme.color.inverse.b1;
    var onTextColor = colorMap.onBlueColor2;
    var atTextColor = theme.color.bk;
    var gapTextColor = theme.color.b1;
    var textColorForBrands = forBrands(theme, {
        br: function () { return brTextColor; },
        brfs: function () { return brTextColor; },
        at: function () { return atTextColor; },
        on: function () { return onTextColor; },
        gap: function () { return gapTextColor; },
        gapfs: function () { return gapTextColor; },
        default: function () { return theme.color.g1; },
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? textColorForBrands : theme.color.g1;
};
var newRedesignTextFontSize = function (theme, isQuickAddRedesignEnabled) {
    var oldBrFontSize = theme.isNewBrFontEnabled ? '1rem' : '0.875rem';
    var newBrFontSize = '0.75rem';
    var newAtFontSize = '0.875rem';
    var oldTextFontSizeForBrands = forBrands(theme, {
        gap: function () { return '1rem'; },
        gapfs: function () { return '1rem'; },
        br: function () { return oldBrFontSize; },
        brfs: function () { return oldBrFontSize; },
        default: function () { return '1.125rem'; },
    });
    var textFontSizeForBrands = forBrands(theme, {
        at: function () { return newAtFontSize; },
        br: function () { return newBrFontSize; },
        brfs: function () { return newBrFontSize; },
        gap: function () { return '0.875rem'; },
        gapfs: function () { return '0.875rem'; },
        default: function () { return '1.125rem'; },
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? textFontSizeForBrands : oldTextFontSizeForBrands;
};
var newRedesignDimensionHeight = function (theme, isQuickAddRedesignEnabled) {
    var defaultValue = '2.125rem';
    var heightRedesignForBrands = forBrands(theme, {
        on: function () { return '2.875rem'; },
        gap: function () { return '2.875rem'; },
        gapfs: function () { return '2.875rem'; },
        default: function () { return defaultValue; },
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? heightRedesignForBrands : defaultValue;
};
var newRedesignUnavailableTextColor = function (theme, isQuickAddRedesignEnabled) {
    var oldUnavailableTextColorForBrands = forBrands(theme, {
        br: function () { return theme.color.g4; },
        brfs: function () { return theme.color.g4; },
        gap: function () { return theme.color.g2; },
        gapfs: function () { return theme.color.g2; },
    });
    var unavailableTextColorForBrands = forBrands(theme, {
        br: function () { return theme.color.inverse.b1; },
        brfs: function () { return theme.color.inverse.b1; },
        at: function () { return theme.color.bk; },
        default: function () { return theme.color.g2; },
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled
        ? unavailableTextColorForBrands
        : oldUnavailableTextColorForBrands;
};
var newRedesignDimensionsSelectedStyles = function (theme, isQuickAddRedesignEnabled) {
    var brDimensionsSelectedStyles = {
        backgroundColor: 'transparent',
        color: theme.color.inverse.b1,
        fontWeight: getFontWeight('semiBold').fontWeight,
    };
    var atDimensionsSelectedStyles = {
        backgroundColor: colorMap.blackColor1,
        color: theme.color.wh,
        fontWeight: getFontWeight('medium').fontWeight,
        padding: 0,
    };
    var onDimensionsSelectedStyles = {
        backgroundColor: colorMap.onBlueColor2,
        color: theme.color.wh,
        fontWeight: getFontWeight('medium').fontWeight,
        padding: 0,
        letterSpacing: '0.75px',
    };
    var gapDimensionsSelectedStyles = {
        backgroundColor: theme.color.b1,
        color: theme.color.wh,
        padding: 0,
        fontWeight: getFontWeight('regular').fontWeight,
    };
    var oldDimensionsSelectedStyles = {
        backgroundColor: theme.color.b1,
        color: theme.color.wh,
        fontWeight: getFontWeight('bold').fontWeight,
    };
    var dimensionsSelectedStylesForBrands = forBrands(theme, {
        br: function () { return brDimensionsSelectedStyles; },
        brfs: function () { return brDimensionsSelectedStyles; },
        at: function () { return atDimensionsSelectedStyles; },
        on: function () { return onDimensionsSelectedStyles; },
        gap: function () { return gapDimensionsSelectedStyles; },
        gapfs: function () { return gapDimensionsSelectedStyles; },
        default: function () { return oldDimensionsSelectedStyles; },
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled
        ? dimensionsSelectedStylesForBrands
        : oldDimensionsSelectedStyles;
};
var newRedesignOOSIndicatorStyles = function (theme, rotate, scale, color, isQuickAddRedesignEnabled) {
    var oldOOSIndicator = { transform: 'scale(1)' };
    var brNewRedesingOOSIndicator = "transform: scale(1) rotate(48deg); line{stroke: " + theme.color.inverse.b1 + "};";
    var atNewRedesingOOSIndicator = "transform: scale(" + scale + ") rotate(" + rotate + "deg); top: 1px; line{stroke: red};";
    var onNewRedesingOOSIndicator = "transform: scale(1) rotate(57deg); width: 26px; top: 2px; left:9px; line{stroke: " + colorMap.blackColor1 + "};";
    var newRedesingOOSIndicatorForBrands = forBrands(theme, {
        br: brNewRedesingOOSIndicator,
        brfs: brNewRedesingOOSIndicator,
        at: atNewRedesingOOSIndicator,
        on: onNewRedesingOOSIndicator,
        default: oldOOSIndicator,
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? newRedesingOOSIndicatorForBrands : oldOOSIndicator;
};
var newRedesignBackgroundColor = function (theme, isQuickAddRedesignEnabled) {
    var brStyles = 'transparent';
    var atStyles = colorMap.atGrayColor2;
    var onStyles = colorMap.onGrayColor;
    var gapStyles = colorMap.onGrayColor;
    var oldStyles = 'transparent';
    var backgroundColorStylesForBrands = forBrands(theme, {
        at: function () { return atStyles; },
        br: function () { return brStyles; },
        brfs: function () { return brStyles; },
        on: function () { return onStyles; },
        gap: function () { return gapStyles; },
        gapfs: function () { return gapStyles; },
        default: oldStyles,
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? backgroundColorStylesForBrands : oldStyles;
};
var newRedesignHoverStyles = function (theme, isAvailable, isQuickAddRedesignEnabled) {
    var atStyles = {
        backgroundColor: colorMap.blackColor1 + "33",
        color: isAvailable ? "" + colorMap.blackColor1 : "" + theme.color.bk,
        fontWeight: getFontWeight('regular').fontWeight,
    };
    var gapStyles = {
        backgroundColor: isAvailable ? colorMap.black2Balpha20 : theme.color.g3,
        color: colorMap.black2B,
    };
    var oldStyles = {};
    var hoverBackgroundColorStylesForBrands = forBrands(theme, {
        at: function () { return atStyles; },
        gap: function () { return gapStyles; },
        default: oldStyles,
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? hoverBackgroundColorStylesForBrands : oldStyles;
};
var newRedesignUnavailableStyles = function (theme, isQuickAddRedesignEnabled) {
    var brUnavailableStyles = {
        color: theme.color.inverse.b1,
        backgroundColor: 'transparent',
        fontWeight: getFontWeight('regular').fontWeight,
    };
    var atUnavailableStyles = "\n    color: white;\n    background-color: " + colorMap.blackColor1 + "66;\n    font-weight: " + getFontWeight('medium').fontWeight + ";\n\n    :hover{\n      color: " + theme.color.bk + ";\n      background-color: " + colorMap.blackColor1 + "33;\n      line{stroke:  " + colorMap.blackColor1 + "80};\n    }\n  ";
    var onUnavailableStyles = {
        backgroundColor: 'transparent',
        fontWeight: getFontWeight('regular').fontWeight,
    };
    var oldUnavailableStyles = {
        color: theme.color.bk,
        backgroundColor: theme.color.gray10,
        fontWeight: getFontWeight('regular').fontWeight,
    };
    var unavailableSelectedStylesForBrands = forBrands(theme, {
        at: function () { return atUnavailableStyles; },
        br: function () { return brUnavailableStyles; },
        brfs: function () { return brUnavailableStyles; },
        on: function () { return onUnavailableStyles; },
        default: oldUnavailableStyles,
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? unavailableSelectedStylesForBrands : oldUnavailableStyles;
};
var newRedesignSelectedAfterStyles = function (theme, isQuickAddRedesignEnabled) {
    var selectedAfter = 'display: block';
    var oldSelectedAfter = 'display: none';
    var selectedAfterStylesForBrands = forBrands(theme, {
        br: function () { return selectedAfter; },
        brfs: function () { return selectedAfter; },
        default: oldSelectedAfter,
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? selectedAfterStylesForBrands : oldSelectedAfter;
};
var newRedesignUnavailableBackgroundColor = function (theme, isQuickAddRedesignEnabled) {
    var atStyles = "\n    background-color: transparent;\n    :hover {\n      background-color: " + colorMap.blackColor1 + "33;\n    }\n  ";
    var onStyles = "\n    background-color: transparent;\n    color: " + colorMap.onBlueColor2 + ";\n  ";
    var gapStyles = "\n    background-color: transparent;\n    color: " + theme.color.b1 + ";\n  ";
    var defaultStyles = {};
    var unavailableTextColorForBrands = forBrands(theme, {
        at: function () { return atStyles; },
        on: function () { return onStyles; },
        gap: function () { return gapStyles; },
        gapfs: function () { return gapStyles; },
        default: function () { return defaultStyles; },
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? unavailableTextColorForBrands : defaultStyles;
};
var newRedesignUnavailableAutoWidth = function (theme, isQuickAddRedesignEnabled) {
    var atStyles = "\n    height: 2.5rem; \n    margin-right: 6px;\n    margin-bottom: 6px;\n  ";
    var brStyles = "\n    margin-top: 0.563rem;\n  ";
    var defaultStyles = 'padding: 0;';
    var unavailableAutoWidthForBrands = forBrands(theme, {
        at: function () { return atStyles; },
        br: function () { return brStyles; },
        default: function () { return defaultStyles; },
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? unavailableAutoWidthForBrands : defaultStyles;
};
var newRedesigndPdpDimension = function (theme, isQuickAddRedesignEnabled) {
    var atStyles = "\n    width: 2.5rem;\n    height:  2.5rem;\n  ";
    var onAndGapStyles = " \n    width: 2.875rem;\n    height:  2.875rem;\n  ";
    var defaultStyles = "\n    width: 2.25rem;\n    height: 2.25rem;\n  ";
    var unavailableAutoWidthLabelForBrands = forBrands(theme, {
        at: function () { return atStyles; },
        on: function () { return onAndGapStyles; },
        gap: function () { return onAndGapStyles; },
        gapfs: function () { return onAndGapStyles; },
        default: function () { return defaultStyles; },
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? unavailableAutoWidthLabelForBrands : defaultStyles;
};

var swatchSize = '40px';
var swatchSpacing = '0.75rem';
var swatchSpacingVertical = '1rem';
function dimensionRadioStyles(theme, isQuickAddRedesignEnabled) {
    var radioBackgroundColor = forBrands(theme, {
        gap: function () { return theme.color.g5; },
        gapfs: function () { return theme.color.g5; },
        at: function () { return theme.color.g5; },
    });
    var radioStyles = forBrands(theme, {
        br: function () { return "1px solid " + theme.color.g4; },
        brfs: function () { return "1px solid " + theme.color.g4; },
        gap: function () { return 'none'; },
        gapfs: function () { return 'none'; },
        on: function () { return "1px solid " + theme.color.b1; },
    });
    var borderRadius = forBrands(theme, {
        at: function () { return '1.5rem'; },
    });
    return css(templateObject_1$1$1 || (templateObject_1$1$1 = __makeTemplateObject$1(["\n    position: relative;\n    display: inline-block;\n    margin-right: ", ";\n    margin-bottom: ", ";\n    text-align: center;\n    transition: all 0.2s;\n    vertical-align: top;\n    background-color: ", ";\n    border: ", ";\n    border-radius: ", ";\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) {\n      width: ", ";\n      height: ", ";\n    }\n\n    &.pdp-dimension--auto-width {\n      width: auto;\n      height: ", ";\n    }\n\n    &.invisible-border {\n      border-right: 0.375rem solid transparent;\n      border-left: 0.375rem solid transparent;\n      margin-right: 0 !important;\n      float: left;\n    }\n\n    & .swatch__out-of-stock-indicator {\n      position: absolute;\n      top: -1px;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      pointer-events: none;\n      border-radius: ", ";\n    }\n\n    & .pdp-dimension__radio {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      margin: 0;\n      z-index: 1;\n      transform: translate(-50%, -50%);\n      opacity: 0;\n    }\n\n    & .pdp-dimension__radio:hover {\n      cursor: pointer;\n    }\n\n    & .pdp-dimension__radio.focus-visible + .pdp-dimension__label {\n      box-shadow: 0 0 0 0.1875rem ", ";\n    }\n\n    &.pdp-dimension.selected::after {\n      content: '';\n      position: absolute;\n      display: block;\n      width: 100%;\n      left: 0;\n      ", "\n    }\n  "], ["\n    position: relative;\n    display: inline-block;\n    margin-right: ", ";\n    margin-bottom: ", ";\n    text-align: center;\n    transition: all 0.2s;\n    vertical-align: top;\n    background-color: ", ";\n    border: ", ";\n    border-radius: ", ";\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) {\n      width: ", ";\n      height: ", ";\n    }\n\n    &.pdp-dimension--auto-width {\n      width: auto;\n      height: ", ";\n    }\n\n    &.invisible-border {\n      border-right: 0.375rem solid transparent;\n      border-left: 0.375rem solid transparent;\n      margin-right: 0 !important;\n      float: left;\n    }\n\n    & .swatch__out-of-stock-indicator {\n      position: absolute;\n      top: -1px;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      pointer-events: none;\n      border-radius: ", ";\n    }\n\n    & .pdp-dimension__radio {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      margin: 0;\n      z-index: 1;\n      transform: translate(-50%, -50%);\n      opacity: 0;\n    }\n\n    & .pdp-dimension__radio:hover {\n      cursor: pointer;\n    }\n\n    & .pdp-dimension__radio.focus-visible + .pdp-dimension__label {\n      box-shadow: 0 0 0 0.1875rem ", ";\n    }\n\n    &.pdp-dimension.selected::after {\n      content: '';\n      position: absolute;\n      display: block;\n      width: 100%;\n      left: 0;\n      ", "\n    }\n  "])), swatchSpacing, swatchSpacingVertical, radioBackgroundColor, radioStyles, borderRadius, swatchSize, swatchSize, swatchSize, borderRadius, theme.crossBrand.color.b2, newRedesignSelectedAfterWrapperStyles(theme, isQuickAddRedesignEnabled));
}
function dimensionRadioFontStyles(theme, gothamFontEnabled, isQuickAddRedesignEnabled) {
    var swatchNaturalLineHeight = forBrands(theme, {
        br: function () { return '2.375'; },
        gap: function () { return '2'; },
        default: function () { return '1.875'; },
    });
    var paddingTop = forBrands(theme, {
        brfs: function () { return '0.27em'; },
        default: function () { return '0'; },
    });
    var paddingLeftAndRightAutoWidth = function () {
        var restylePaddingLarge = '8px';
        var paddingLeftAndRightAutoWidthStyles = forBrands(theme, {
            on: function () { return restylePaddingLarge; },
            gap: function () { return restylePaddingLarge; },
            gapfs: function () { return restylePaddingLarge; },
            at: function () { return restylePaddingLarge; },
            default: function () { return '0.875em'; },
        });
        return theme.isNewRedesign || isQuickAddRedesignEnabled ? paddingLeftAndRightAutoWidthStyles : '0.875em';
    };
    var paddingLeftAndRight = function () {
        var restylePaddingSmall = '4px';
        var paddingLeftAndRightStyles = forBrands(theme, {
            on: function () { return restylePaddingSmall; },
            gap: function () { return restylePaddingSmall; },
            gapfs: function () { return restylePaddingSmall; },
            at: function () { return restylePaddingSmall; },
            default: function () { return '0.875em'; },
        });
        return theme.isNewRedesign || isQuickAddRedesignEnabled ? paddingLeftAndRightStyles : '0.875em';
    };
    var textAlign = function () {
        var alignCenter = "\n      display: flex;\n      align-items:center;\n    ";
        var textAlignStyles = forBrands(theme, {
            gap: alignCenter,
            gapfs: alignCenter,
            at: alignCenter,
            default: '',
        });
        return theme.isNewRedesign || isQuickAddRedesignEnabled ? textAlignStyles : '';
    };
    var textLetterSpacing = forBrands(theme, {
        br: function () { return '1px'; },
    });
    var textFontWeight = forBrands(theme, {
        at: function () { return getFontWeight('regular'); },
        br: function () { return getFontWeight('regular'); },
    });
    var textTopPosition = forBrands(theme, {
        at: theme.isNewRedesign || isQuickAddRedesignEnabled ? '50%' : '45%',
        default: '50%',
    });
    var unavailableTextFont = forBrands(theme, {
        gap: function () { return theme.crossBrand.font.primary; },
        gapfs: function () { return theme.crossBrand.font.primary; },
    });
    var dimensionHoverStyles = forBrands(theme, {
        gap: newRedesignDimensionsSelectedStyles(theme, isQuickAddRedesignEnabled),
        default: newRedesignHoverStyles(theme, true, isQuickAddRedesignEnabled),
    });
    return css(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject$1(["\n    margin-bottom: 0.8125rem;\n    border: none;\n    text-transform: uppercase;\n    ", "\n    font-size: ", ";\n    color: ", ";\n    letter-spacing: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    background-color: ", ";\n    position: relative;\n    ", "\n\n    &.pdp-dimension {\n      :hover {\n        ", ";\n      }\n    }\n\n    ", "\n\n    &.selected {\n      ", "\n      :hover {\n        ", "\n      }\n\n      &.pdp-dimension--auto-width .swatch__out-of-stock-indicator {\n        ", "\n      }\n    }\n\n    &.selected.pdp-dimension--unavailable {\n      ", ";\n    }\n\n    &.pdp-dimension--unavailable {\n      color: ", ";\n      font-family: ", ";\n      ", ";\n      :hover {\n        ", ";\n      }\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) {\n      ", ";\n    }\n\n    &.pdp-dimension--auto-width {\n      width: auto;\n      height: ", ";\n      margin-right: 0;\n      margin-bottom: 0.125rem;\n      ", ";\n    }\n\n    & .pdp-dimension__label {\n      border-radius: 2rem;\n      padding: ", " ", " 0;\n    }\n\n    &.pdp-dimension--auto-width .pdp-dimension__label {\n      width: auto;\n      margin-right: 0;\n      position: relative;\n      padding: ", " ", " 0;\n      ", "\n      ", "\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) .pdp-dimension__text {\n      top: ", ";\n    }\n\n    &.pdp-dimension.selected::after {\n      ", "\n    }\n\n    &.pdp-dimension--unavailable .pdp-dimension__radio:checked + .pdp-dimension__label .pdp-dimension__text {\n      opacity: 0.5;\n      ", "\n    }\n\n    &.pdp-dimension .swatch__out-of-stock-indicator {\n      ", "\n      border-radius: 50%;\n    }\n\n    &.selected .swatch__out-of-stock-indicator {\n      ", "\n    }\n\n    &.pdp-dimension--auto-width .swatch__out-of-stock-indicator {\n      ", "\n      border-radius: 2rem;\n    }\n  "], ["\n    margin-bottom: 0.8125rem;\n    border: none;\n    text-transform: uppercase;\n    ", "\n    font-size: ", ";\n    color: ", ";\n    letter-spacing: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    background-color: ", ";\n    position: relative;\n    ", "\n\n    &.pdp-dimension {\n      :hover {\n        ", ";\n      }\n    }\n\n    ", "\n\n    &.selected {\n      ", "\n      :hover {\n        ", "\n      }\n\n      &.pdp-dimension--auto-width .swatch__out-of-stock-indicator {\n        ", "\n      }\n    }\n\n    &.selected.pdp-dimension--unavailable {\n      ", ";\n    }\n\n    &.pdp-dimension--unavailable {\n      color: ", ";\n      font-family: ", ";\n      ", ";\n      :hover {\n        ", ";\n      }\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) {\n      ", ";\n    }\n\n    &.pdp-dimension--auto-width {\n      width: auto;\n      height: ", ";\n      margin-right: 0;\n      margin-bottom: 0.125rem;\n      ", ";\n    }\n\n    & .pdp-dimension__label {\n      border-radius: 2rem;\n      padding: ", " ", " 0;\n    }\n\n    &.pdp-dimension--auto-width .pdp-dimension__label {\n      width: auto;\n      margin-right: 0;\n      position: relative;\n      padding: ", " ", " 0;\n      ", "\n      ",
        "\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) .pdp-dimension__text {\n      top: ", ";\n    }\n\n    &.pdp-dimension.selected::after {\n      ", "\n    }\n\n    &.pdp-dimension--unavailable .pdp-dimension__radio:checked + .pdp-dimension__label .pdp-dimension__text {\n      opacity: 0.5;\n      ", "\n    }\n\n    &.pdp-dimension .swatch__out-of-stock-indicator {\n      ", "\n      border-radius: 50%;\n    }\n\n    &.selected .swatch__out-of-stock-indicator {\n      ", "\n    }\n\n    &.pdp-dimension--auto-width .swatch__out-of-stock-indicator {\n      ", "\n      border-radius: 2rem;\n    }\n  "])), theme.font.primary, newRedesignTextFontSize(theme, isQuickAddRedesignEnabled), newRedesignTextColor(theme, isQuickAddRedesignEnabled), textLetterSpacing, textFontWeight, swatchNaturalLineHeight, newRedesignBackgroundColor(theme, isQuickAddRedesignEnabled), newRedesingForDimensionRadioStyles(theme, isQuickAddRedesignEnabled), newRedesignHoverStyles(theme, true, isQuickAddRedesignEnabled), gothamFontEnabled && "font-size: 0.875rem;", newRedesignDimensionsSelectedStyles(theme, isQuickAddRedesignEnabled), dimensionHoverStyles, newRedesignOOSIndicatorStyles(theme, 38, 0.85, theme.color.wh + "66", isQuickAddRedesignEnabled), newRedesignUnavailableStyles(theme, isQuickAddRedesignEnabled), newRedesignUnavailableTextColor(theme, isQuickAddRedesignEnabled), unavailableTextFont, newRedesignUnavailableBackgroundColor(theme, isQuickAddRedesignEnabled), newRedesignHoverStyles(theme, false, isQuickAddRedesignEnabled), newRedesigndPdpDimension(theme, isQuickAddRedesignEnabled), newRedesignDimensionHeight(theme, isQuickAddRedesignEnabled), newRedesignUnavailableAutoWidth(theme, isQuickAddRedesignEnabled), paddingTop, paddingLeftAndRight(), paddingTop, paddingLeftAndRightAutoWidth(), textAlign(), gothamFontEnabled &&
        "\n        display: flex;\n        align-items: center;\n      ", textTopPosition, newRedesignSelectedAfterStyles(theme, isQuickAddRedesignEnabled), newRedesignUnavailableSelectedOpacity(theme, isQuickAddRedesignEnabled), newRedesignOOSIndicatorStyles(theme, 45, 0.7, theme.color.wh + "33", isQuickAddRedesignEnabled), newRedesignUnavailableSelectedIndicator(theme, isQuickAddRedesignEnabled), newRedesignOOSIndicatorStyles(theme, 40, 0.85, theme.color.wh + "33", isQuickAddRedesignEnabled));
}
var templateObject_1$1$1, templateObject_2$2;

var isBananaRepublic$1 = function (brand) {
    var brands = [Brands.BananaRepublic, Brands.BananaRepublicFactoryStore];
    return brands.join(',').includes(brand.toLowerCase());
};

var newRedesignVariantSelectedStyles = function (theme, isNewBrFontEnabled, isQuickAddRedesignEnabled) {
    var brSelectedStyles = {};
    var defaultSelectedStyles = { padding: '2px' };
    var variantSelectedStylesForBrands = forBrands(theme, {
        br: function () { return brSelectedStyles; },
        brfs: function () { return brSelectedStyles; },
        default: function () { return defaultSelectedStyles; },
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled || !isNewBrFontEnabled
        ? variantSelectedStylesForBrands
        : defaultSelectedStyles;
};
var newRedesignDimensionTextStyles = function (theme, isQuickAddRedesignEnabled) {
    var brDimensionTextStyles = 'line-height: 0.875rem; letter-spacing: 0.75px; text-transform: uppercase;';
    var defaultDimensionTextStyles = {};
    var dimensionTextStylesForBrands = forBrands(theme, {
        br: brDimensionTextStyles,
        brfs: brDimensionTextStyles,
        default: function () { return defaultDimensionTextStyles; },
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? dimensionTextStylesForBrands : defaultDimensionTextStyles;
};

function useTextStyles(theme, isQuickAddRedesignEnabled, brandName) {
    var enabledFeatures = useContext(FeatureFlagsContext).enabledFeatures;
    var brand = useAppState$1().brandName;
    var abbrBrand = brandName || brand;
    var newFontFeatureFlag = isBananaRepublic$1(abbrBrand) ? 'enable-new-br-fonts' : '';
    var isNewBrFontEnabled = enabledFeatures[newFontFeatureFlag];
    var naturalLineHeight = forBrands(theme, {
        gap: function () { return '41px'; },
        gapfs: function () { return '41px'; },
        br: function () { return '41px'; },
        brfs: function () { return '41px'; },
        on: function () { return '42px'; },
        at: function () { return '39px'; },
    });
    var swatchTextColor = forBrands(theme, {
        gap: theme.color.b2,
        gapfs: theme.color.b2,
        br: function () { return theme.color.g2; },
        brfs: function () { return theme.color.g3; },
        on: function () { return theme.color.b1; },
    });
    var checkedSwatchColor = forBrands(theme, {
        br: function () { return theme.color.g1; },
        brfs: function () { return theme.color.g1; },
        on: function () { return theme.color.g1; },
    });
    var checkedBackgroundColor = forBrands(theme, {
        br: function () { return theme.color.g1; },
        brfs: function () { return theme.color.g1; },
        on: function () { return theme.color.g1; },
        at: function () { return theme.color.g5; },
    });
    var checkedSwatchTextColor = forBrands(theme, {
        gap: function () { return theme.color.b1; },
        gapfs: function () { return theme.color.b1; },
        br: function () { return theme.color.wh; },
        brfs: function () { return theme.color.wh; },
        on: function () { return theme.color.wh; },
    });
    var checkedSwatchFont = forBrands(theme, {
        gap: function () { return theme.crossBrand.font.secondary; },
        at: function () { return theme.crossBrand.font.secondary; },
    });
    var checkedSwatchFontWeight = forBrands(theme, {
        gapfs: function () { return 700; },
    });
    var unavailableTextColor = forBrands(theme, {
        at: function () { return theme.color.b1; },
        br: function () { return theme.color.g4; },
        brfs: function () { return theme.color.g4; },
        gap: function () { return theme.color.g2; },
        gapfs: function () { return theme.color.g2; },
    });
    var unavailableTextFont = forBrands(theme, {
        gap: function () { return theme.crossBrand.font.primary; },
        gapfs: function () { return theme.crossBrand.font.primary; },
    });
    var unavailableCheckedBackground = forBrands(theme, {
        on: function () { return theme.color.wh; },
    });
    var unavailableCheckedBorder = forBrands(theme, {
        on: function () { return theme.color.g4; },
    });
    var unavailableCheckedTextColor = forBrands(theme, {
        on: function () { return theme.color.g3; },
    });
    var textFontSize = forBrands(theme, {
        gap: '0.933rem',
        gapfs: '0.933rem',
        on: function () { return '0.9rem'; },
        br: function () { return (isNewBrFontEnabled ? '1rem' : '0.8125rem'); },
        at: function () { return '1rem'; },
        default: function () { return '0.8125rem'; },
    });
    var swatchTextTransform = forBrands(theme, {
        gap: 'uppercase',
        gapfs: 'uppercase',
        on: 'uppercase',
        br: 'uppercase',
    });
    return css(templateObject_1$2$1 || (templateObject_1$2$1 = __makeTemplateObject$1(["\n    text-transform: ", ";\n    letter-spacing: normal;\n    font-size: ", ";\n    font-weight: 400;\n    color: ", ";\n    ", "\n    line-height: ", ";\n    white-space: nowrap;\n\n    &.selected {\n      font-family: ", ";\n      color: ", ";\n      font-weight: ", ";\n      border-color: ", ";\n      background-color: ", ";\n      ", ";\n    }\n\n    &.pdp-dimension--unavailable {\n      color: ", ";\n      font-family: ", ";\n    }\n\n    &.selected.pdp-dimension--unavailable {\n      color: ", ";\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    & .pdp-dimension__text {\n      display: block;\n      position: relative;\n      ", "\n    }\n\n    & .pdp-dimension__label {\n      box-sizing: border-box;\n      display: inline-block;\n      width: 100%;\n      height: 100%;\n    }\n\n    &.pdp-dimension--auto-width .pdp-dimension__label {\n      padding: 0 1em;\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      border-radius: 50%;\n      z-index: 1;\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) .pdp-dimension__text {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) .pdp-dimension__label {\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      border-radius: 50%;\n      z-index: 1;\n    }\n\n    &.pdp-dimension.pdp-dimension--auto-width .pdp-dimension__label {\n      z-index: 0;\n    }\n  "], ["\n    text-transform: ", ";\n    letter-spacing: normal;\n    font-size: ", ";\n    font-weight: 400;\n    color: ", ";\n    ", "\n    line-height: ", ";\n    white-space: nowrap;\n\n    &.selected {\n      font-family: ", ";\n      color: ", ";\n      font-weight: ", ";\n      border-color: ", ";\n      background-color: ", ";\n      ", ";\n    }\n\n    &.pdp-dimension--unavailable {\n      color: ", ";\n      font-family: ", ";\n    }\n\n    &.selected.pdp-dimension--unavailable {\n      color: ", ";\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    & .pdp-dimension__text {\n      display: block;\n      position: relative;\n      ", "\n    }\n\n    & .pdp-dimension__label {\n      box-sizing: border-box;\n      display: inline-block;\n      width: 100%;\n      height: 100%;\n    }\n\n    &.pdp-dimension--auto-width .pdp-dimension__label {\n      padding: 0 1em;\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      border-radius: 50%;\n      z-index: 1;\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) .pdp-dimension__text {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) .pdp-dimension__label {\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      border-radius: 50%;\n      z-index: 1;\n    }\n\n    &.pdp-dimension.pdp-dimension--auto-width .pdp-dimension__label {\n      z-index: 0;\n    }\n  "])), swatchTextTransform, textFontSize, swatchTextColor, theme.font.primary, naturalLineHeight, checkedSwatchFont, checkedSwatchTextColor, checkedSwatchFontWeight, checkedSwatchColor, checkedBackgroundColor, newRedesignVariantSelectedStyles(theme, isNewBrFontEnabled, isQuickAddRedesignEnabled), unavailableTextColor, unavailableTextFont, unavailableCheckedTextColor, unavailableCheckedBackground, unavailableCheckedBorder, newRedesignDimensionTextStyles(theme, isQuickAddRedesignEnabled));
}
var templateObject_1$2$1;

var newRedesignQuickAddMargin = function (theme, defaultValue, isQuickAddRedesignEnabled) {
    var dimensionMargin = forBrands(theme, {
        on: function () { return (isQuickAddRedesignEnabled ? 'margin: 0.375rem 0.21875rem' : defaultValue); },
        at: function () { return (isQuickAddRedesignEnabled ? 'margin: 0 0.375rem 0.375rem 0' : defaultValue); },
        gap: function () { return (theme.isNewRedesign || isQuickAddRedesignEnabled ? 'margin: 0.1875rem 0.21875rem;' : defaultValue); },
        gapfs: function () { return (theme.isNewRedesign || isQuickAddRedesignEnabled ? 'margin: 0.1875rem 0.21875rem;' : defaultValue); },
        default: defaultValue,
    });
    return dimensionMargin;
};
var newRedesignQuickAddDimension = function (theme, isQuickAddRedesignEnabled) {
    var onAndGapStyles = " \n    width: 2.875rem;\n    height:  2.875rem;\n  ";
    var atStyles = "\n    width: 2.5rem;\n    height: 2.5rem;\n  ";
    var defaultStyles = "\n    width: 2.25rem;\n    height: 2.25rem;\n  ";
    var dimensionsForBrands = forBrands(theme, {
        on: onAndGapStyles,
        gap: onAndGapStyles,
        gapfs: onAndGapStyles,
        at: atStyles,
        default: defaultStyles,
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? dimensionsForBrands : defaultStyles;
};
var newRedesignQuickAddAutoWidthDimension = function (theme, isQuickAddRedesignEnabled) {
    var defaultStyles = 'height: 2.25rem;';
    var dimensionsAutoWidthForBrands = forBrands(theme, {
        on: function () { return 'height: 2.875rem;'; },
        at: function () { return 'height: 2.5rem;'; },
        br: function () { return 'margin-top: 0.188rem'; },
        default: function () { return defaultStyles; },
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? dimensionsAutoWidthForBrands : defaultStyles;
};
var newRedesignQuickAddLabelPaddingAutoWidth = function (theme, isQuickAddRedesignEnabled) {
    var defaultStyles = '0 0.7em';
    var paddignAutoWidthForBrands = forBrands(theme, {
        on: function () { return '0 8px'; },
        at: function () { return '0 5px'; },
        default: function () { return defaultStyles; },
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? paddignAutoWidthForBrands : defaultStyles;
};
var newRedesignFourthElementMargin = function (theme, isQuickAddRedesignEnabled) {
    var defaultStyles = 'margin-right: 0px';
    var fourthElementMargin = forBrands(theme, {
        on: function () { return ''; },
        at: function () { return ''; },
        gap: function () { return ''; },
        gapfs: function () { return ''; },
        default: function () { return defaultStyles; },
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? fourthElementMargin : defaultStyles;
};
var newRedesignSelectedFontWeight = function (theme, isQuickAddRedesignEnabled) {
    var defaultStyles = getFontWeight('bold');
    var selectedFontWeightForBrands = forBrands(theme, {
        on: function () { return getFontWeight('medium'); },
        at: function () { return getFontWeight('medium'); },
        gap: function () { return getFontWeight('regular'); },
        gapfs: function () { return getFontWeight('regular'); },
        default: function () { return getFontWeight('bold'); },
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? selectedFontWeightForBrands : defaultStyles;
};
var newRedesignContentAlign = function (theme, isQuickAddRedesignEnabled) {
    var defaultStyles = '';
    var contentAlignForBrands = forBrands(theme, {
        at: "\n      display: flex;\n      align-items: center;\n    ",
        default: defaultStyles,
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? contentAlignForBrands : defaultStyles;
};
var newRedesignUnavailableSelected = function (theme, isQuickAddRedesignEnabled) {
    var defaultStyles = "\n    background-color: " + theme.color.gray10 + ";\n    color: " + theme.color.bk + ";\n  ";
    var gapUnavailableSelectedStyles = "\n    background-color: " + colorMap.gapDarkGray + ";\n    color: " + theme.color.wh + ";\n    opacity: 1;\n\n      .pdp-dimension__text::before {\n        border-top: 1px solid " + theme.color.wh + ";\n      }\n    }\n  ";
    var unavailableSelectedStyles = forBrands(theme, {
        at: "\n      color: " + theme.color.wh + ";\n      background-color: " + colorMap.blackColor1 + "66;\n    ",
        on: "\n      background: transparent;\n    ",
        gap: gapUnavailableSelectedStyles,
        gapfs: gapUnavailableSelectedStyles,
        default: defaultStyles,
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? unavailableSelectedStyles : defaultStyles;
};
var newRedesignOpacityUnavailableSelected = function (theme, isQuickAddRedesignEnabled) {
    var defaultStyles = '0.5';
    var opacityStyles = forBrands(theme, {
        at: '1',
        gap: '1',
        gapfs: '1',
        default: defaultStyles,
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? opacityStyles : defaultStyles;
};

function quickAddStyles(theme, gothamFontEnabled, isQuickAddRedesignEnabled) {
    return css(templateObject_1$3$1 || (templateObject_1$3$1 = __makeTemplateObject$1(["\n    font-size: 0.75rem;\n    line-height: 2.125;\n\n    &.selected {\n      ", ";\n    }\n\n    &.pdp-dimension--unavailable {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n\n    &.selected.pdp-dimension--unavailable {\n      font-weight: 400;\n      ", "\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) {\n      width: 1.875rem;\n      height: 1.875rem;\n      margin: 0 0.5rem 0.75rem;\n    }\n\n    &.pdp-dimension--auto-width {\n      width: auto;\n      height: 1.875rem;\n      margin-bottom: 0;\n      margin-right: 0;\n      margin-left: 0;\n      font-size: 0.875rem;\n    }\n\n    & .pdp-dimension__label {\n      border-radius: 2rem;\n    }\n\n    &.pdp-dimension--auto-width .pdp-dimension__label {\n      width: auto;\n      margin-right: 0;\n      padding: ", ";\n      ", "\n      ", "\n    }\n\n    & .pdp-dimension__radio.focus-visible + .pdp-dimension__label {\n      outline: 0;\n      box-shadow: 0 0 0 3px ", ";\n    }\n\n    & .swatch__out-of-stock-indicator {\n      z-index: 2;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      pointer-events: none;\n      transform: scale(1);\n      border-radius: 50%;\n    }\n\n    &.pdp-dimension--auto-width .swatch__out-of-stock-indicator {\n      transform: scale(1);\n      border-radius: 1rem;\n    }\n\n    &.pdp-dimension--unavailable.selected .pdp-dimension__radio:checked + .pdp-dimension__label .pdp-dimension__text {\n      opacity: ", ";\n    }\n  "], ["\n    font-size: 0.75rem;\n    line-height: 2.125;\n\n    &.selected {\n      ", ";\n    }\n\n    &.pdp-dimension--unavailable {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n\n    &.selected.pdp-dimension--unavailable {\n      font-weight: 400;\n      ", "\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) {\n      width: 1.875rem;\n      height: 1.875rem;\n      margin: 0 0.5rem 0.75rem;\n    }\n\n    &.pdp-dimension--auto-width {\n      width: auto;\n      height: 1.875rem;\n      margin-bottom: 0;\n      margin-right: 0;\n      margin-left: 0;\n      font-size: 0.875rem;\n    }\n\n    & .pdp-dimension__label {\n      border-radius: 2rem;\n    }\n\n    &.pdp-dimension--auto-width .pdp-dimension__label {\n      width: auto;\n      margin-right: 0;\n      padding: ", ";\n      ", "\n      ",
        "\n    }\n\n    & .pdp-dimension__radio.focus-visible + .pdp-dimension__label {\n      outline: 0;\n      box-shadow: 0 0 0 3px ", ";\n    }\n\n    & .swatch__out-of-stock-indicator {\n      z-index: 2;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      pointer-events: none;\n      transform: scale(1);\n      border-radius: 50%;\n    }\n\n    &.pdp-dimension--auto-width .swatch__out-of-stock-indicator {\n      transform: scale(1);\n      border-radius: 1rem;\n    }\n\n    &.pdp-dimension--unavailable.selected .pdp-dimension__radio:checked + .pdp-dimension__label .pdp-dimension__text {\n      opacity: ", ";\n    }\n  "])), newRedesignSelectedFontWeight(theme, isQuickAddRedesignEnabled), theme.color.wh, theme.color.g4, theme.color.bk, newRedesignUnavailableSelected(theme, isQuickAddRedesignEnabled), newRedesignQuickAddLabelPaddingAutoWidth(theme, isQuickAddRedesignEnabled), newRedesignContentAlign(theme, isQuickAddRedesignEnabled), gothamFontEnabled &&
        "\n        display: flex;\n        align-items: center;\n      ", theme.crossBrand.color.b2, newRedesignOpacityUnavailableSelected(theme, isQuickAddRedesignEnabled));
}
function quickAddWithImageStyles(theme, gothamFontEnabled, isQuickAddRedesignEnabled) {
    return css(templateObject_2$1$1 || (templateObject_2$1$1 = __makeTemplateObject$1(["\n    ", ";\n    line-height: 2;\n\n    &.pdp-dimension--auto-width {\n      ", ";\n      ", ";\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) {\n      ", ";\n      ", ";\n\n      :nth-of-type(4n) {\n        ", ";\n      }\n\n      @media (max-width: 320px) {\n        ", ";\n      }\n\n      @media (max-width: 693px) {\n        ", ";\n      }\n    }\n  "], ["\n    ", ";\n    line-height: 2;\n\n    &.pdp-dimension--auto-width {\n      ", ";\n      ", ";\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) {\n      ", ";\n      ", ";\n\n      :nth-of-type(4n) {\n        ", ";\n      }\n\n      @media (max-width: 320px) {\n        ", ";\n      }\n\n      @media (max-width: 693px) {\n        ", ";\n      }\n    }\n  "])), quickAddStyles(theme, gothamFontEnabled, isQuickAddRedesignEnabled), newRedesignQuickAddAutoWidthDimension(theme, isQuickAddRedesignEnabled), newRedesignQuickAddMargin(theme, '', isQuickAddRedesignEnabled), newRedesignQuickAddDimension(theme, isQuickAddRedesignEnabled), newRedesignQuickAddMargin(theme, 'margin-right: 2.6875rem', isQuickAddRedesignEnabled), newRedesignFourthElementMargin(theme, isQuickAddRedesignEnabled), newRedesignQuickAddMargin(theme, 'margin-right: 1.25rem', isQuickAddRedesignEnabled), newRedesignQuickAddMargin(theme, 'margin-right: 2.1875rem', isQuickAddRedesignEnabled));
}
var templateObject_1$3$1, templateObject_2$1$1;

var dimensionGroupsContainerStyles = function (theme, isQuickAddRedesignEnabled) {
    var redesignTextColor = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? theme.color.b2 + " !important" : '',
        brfs: isQuickAddRedesignEnabled ? theme.color.b2 + " !important" : '',
        default: '',
    });
    var redesignCenterAlignItems = forBrands(theme, {
        gap: isQuickAddRedesignEnabled ? 'center' : '',
        gapfs: isQuickAddRedesignEnabled ? 'center' : '',
        default: '',
    });
    var redesignDisplay = forBrands(theme, {
        gap: isQuickAddRedesignEnabled ? 'flex' : '',
        gapfs: isQuickAddRedesignEnabled ? 'flex' : '',
        default: '',
    });
    var redesignBorderColor = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? "1px solid " + theme.color.b2 + " !important;" : '',
        brfs: isQuickAddRedesignEnabled ? "1px solid " + theme.color.b2 + " !important;" : '',
        default: '',
    });
    var inputBackgroundColor = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? theme.color.inverse.b1 + " !important;" : '',
        brfs: isQuickAddRedesignEnabled ? theme.color.inverse.b1 + " !important;" : '',
        default: '',
    });
    var labelFontWeight = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? 600 : 400,
        brfs: isQuickAddRedesignEnabled ? 600 : 400,
        default: 400,
    });
    var labelColor = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? theme.color.b2 : theme.color.bk,
        brfs: isQuickAddRedesignEnabled ? theme.color.b2 : theme.color.bk,
        default: theme.color.bk,
    });
    var brDimensionTextStyles = css(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n    text-transform: none !important;\n    line-height: initial !important;\n  "], ["\n    text-transform: none !important;\n    line-height: initial !important;\n  "])));
    var brDimensionText = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? brDimensionTextStyles : {},
        brfs: isQuickAddRedesignEnabled ? brDimensionTextStyles : {},
        default: {},
    });
    var brDimensionMargin = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? 'margin-top: -0.125rem' : {},
    });
    var marginRightPdpDimension = forBrands(theme, {
        gap: isQuickAddRedesignEnabled ? '' : '0.5rem',
        gapfs: isQuickAddRedesignEnabled ? '' : '0.5rem',
        default: '0.5rem',
    });
    return css(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n    .pdp-dimension {\n      color: ", ";\n\n      & .pdp-dimension__text {\n        ", ";\n      }\n\n      .pdp-dimension__text::before {\n        border-top: ", ";\n      }\n\n      &.selected {\n        color: ", ";\n      }\n\n      &.selected::after {\n        border-top: ", ";\n        border-bottom: ", ";\n        background: ", ";\n      }\n\n      &--unavailable {\n        background-color: ", ";\n      }\n    }\n\n    > :first-of-type .radio-container__label {\n      ", "\n      margin-left: 0;\n    }\n\n    .radio-container__label {\n      margin-left: 0.5rem;\n      font-weight: ", " !important;\n      color: ", " !important;\n      align-items: ", ";\n      display: ", ";\n    }\n\n    .radio-container {\n      display: flex;\n      justify-content: ", ";\n    }\n\n    .radio-container:not(:first-of-type):last-child {\n      margin-bottom: 2.125rem;\n\n      .dimension-group {\n        align-content: center;\n\n        .pdp-dimension {\n          margin-right: ", ";\n          margin-bottom: 0;\n          ", "\n        }\n      }\n    }\n  "], ["\n    .pdp-dimension {\n      color: ", ";\n\n      & .pdp-dimension__text {\n        ", ";\n      }\n\n      .pdp-dimension__text::before {\n        border-top: ", ";\n      }\n\n      &.selected {\n        color: ", ";\n      }\n\n      &.selected::after {\n        border-top: ", ";\n        border-bottom: ", ";\n        background: ", ";\n      }\n\n      &--unavailable {\n        background-color: ", ";\n      }\n    }\n\n    > :first-of-type .radio-container__label {\n      ", "\n      margin-left: 0;\n    }\n\n    .radio-container__label {\n      margin-left: 0.5rem;\n      font-weight: ", " !important;\n      color: ", " !important;\n      align-items: ", ";\n      display: ", ";\n    }\n\n    .radio-container {\n      display: flex;\n      justify-content: ", ";\n    }\n\n    .radio-container:not(:first-of-type):last-child {\n      margin-bottom: 2.125rem;\n\n      .dimension-group {\n        align-content: center;\n\n        .pdp-dimension {\n          margin-right: ", ";\n          margin-bottom: 0;\n          ", "\n        }\n      }\n    }\n  "])), redesignTextColor, brDimensionText, redesignBorderColor, redesignTextColor, redesignBorderColor, redesignBorderColor, redesignTextColor, inputBackgroundColor, visuallyHide(), labelFontWeight, labelColor, redesignCenterAlignItems, redesignDisplay, redesignCenterAlignItems, marginRightPdpDimension, brDimensionMargin);
};
var radioGroupStyles = function (theme, gothamFontEnabled, isNewBrFontEnabled, isQuickAddRedesignEnabled) {
    var brFontWeightStyles = forBrands(theme, {
        br: function () { return (isNewBrFontEnabled ? 400 : 700); },
        brfs: function () { return (isNewBrFontEnabled ? 400 : 700); },
        default: function () { return 700; },
    });
    var redesignAlignDimensionGroup = forBrands(theme, {
        gap: theme.isNewRedesign || isQuickAddRedesignEnabled ? 'center' : 'flex-start',
        gapfs: theme.isNewRedesign || isQuickAddRedesignEnabled ? 'center' : 'flex-start',
        default: 'flex-start',
    });
    return css(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n    display: flex;\n    margin-bottom: 0;\n    padding: 0;\n\n    .dimension-group {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: ", ";\n    }\n\n    & .radio-container__label {\n      line-height: 2.5;\n      margin-right: 0.5rem;\n      font-weight: ", ";\n    }\n\n    & .radio-container__label {\n      line-height: ", ";\n\n      @media (max-width: 693px) {\n        ", "\n      }\n    }\n  "], ["\n    display: flex;\n    margin-bottom: 0;\n    padding: 0;\n\n    .dimension-group {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: ", ";\n    }\n\n    & .radio-container__label {\n      line-height: 2.5;\n      margin-right: 0.5rem;\n      font-weight: ", ";\n    }\n\n    & .radio-container__label {\n      line-height: ", ";\n\n      @media (max-width: 693px) {\n        ", "\n      }\n    }\n  "])), redesignAlignDimensionGroup, brFontWeightStyles, gothamFontEnabled ? '2.5' : '2.1', !gothamFontEnabled && 'line-height: 2.2;');
};
var dimensionRadioStyles$1 = function (theme, gothamFontEnabled, isQuickAddRedesignEnabled, brandName) {
    if (isQuickAddRedesignEnabled === void 0) { isQuickAddRedesignEnabled = false; }
    return css(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n"])), dimensionRadioStyles(theme, isQuickAddRedesignEnabled), useTextStyles(theme, isQuickAddRedesignEnabled, brandName), dimensionRadioFontStyles(theme, gothamFontEnabled, isQuickAddRedesignEnabled), quickAddWithImageStyles(theme, gothamFontEnabled, isQuickAddRedesignEnabled));
};
var templateObject_1$6, templateObject_2$3, templateObject_3$1, templateObject_4$1;

function DimensionGroups(_a) {
    var brandName = _a.brandName, dimensions = _a.dimensions, selectedDimensions = _a.selectedDimensions, outOfStockDimensions = _a.outOfStockDimensions, isQuickAddRedesignEnabled = _a.isQuickAddRedesignEnabled, dispatch = _a.dispatch, pid = _a.pid;
    var enabledFeatures = useContext(FeatureFlagsContext).enabledFeatures;
    var gothamFontEnabled = enabledFeatures["enable-" + brandName + "-gotham-font"];
    var brFontFeatureFlag = isBananaRepublic(brandName) ? 'enable-new-br-fonts' : '';
    var brFontEnabled = enabledFeatures[brFontFeatureFlag];
    return (jsx("div", { css: function (theme) {
            return css(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), dimensionGroupsContainerStyles(theme, isQuickAddRedesignEnabled));
        } }, dimensions.map(function (dimension) {
        var label = dimension.label;
        return (jsx("div", { key: label, "aria-labelledby": label + "-group", className: "radio-container radio-container--dimension", css: function (theme) { return css(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n                ", "\n              "], ["\n                ", "\n              "])), radioGroupStyles(theme, gothamFontEnabled, brFontEnabled)); }, role: "radiogroup" },
            jsx("span", { className: "radio-container__label", id: label + "-group" },
                label,
                jsx("span", { "aria-hidden": "true" }, ":")),
            jsx("div", { className: "dimension-group" }, dimension.measurements.map(function (measurement) {
                var _a;
                return (jsx(DimensionRadio, { key: measurement, css: function (theme) { return css(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n                      ", "\n                    "], ["\n                      ", "\n                    "])), dimensionRadioStyles$1(theme, gothamFontEnabled, isQuickAddRedesignEnabled, brandName)); }, id: pid + "-" + label + "-" + measurement, inStock: !((_a = outOfStockDimensions[dimension.label]) === null || _a === void 0 ? void 0 : _a.has(measurement)), name: "quick-add--" + label, onChange: function () {
                        dispatch({
                            type: DIMENSION_CHANGE,
                            payload: { dimension: dimension, measurement: measurement },
                        });
                    }, selected: selectedDimensions[dimension.label] === measurement, shouldDisplayInStock: true, value: measurement }));
            }))));
    })));
}
var templateObject_1$7, templateObject_2$4, templateObject_3$2;

/** @jsx jsx */
var VariantRadio = function (props) {
    var id = props.id, variant = props.variant, selected = props.selected, onBlur = props.onBlur, onChange = props.onChange, className = props.className;
    var name = variant.name;
    var variantClasses = classnames('pdp-variant', { selected: selected });
    return (jsx("div", { className: className + " " + variantClasses },
        jsx("input", { "aria-label": name, checked: selected, className: "pdp-variant__radio", id: id, name: "fit-radio", onBlur: onBlur, onChange: onChange, type: "radio", value: name }),
        jsx("label", { "aria-hidden": true, className: "pdp-variant__label", htmlFor: id }, name)));
};

var colorMap$1 = {
    brLightColor2: '#F6F1EC',
    blackColor1: '#111111',
    blackColor2: '#2C2824',
    atGrayColor: '#757575',
    atGrayColor2: '#EFEFEF',
    brDarkGray: '#403C38',
    brLightColor4: '#E2E0D7',
    brGreyColor2: '#CECBC3',
    onBlueColor: '#004779',
    onBlueColor2: '#002554',
    onBlueColor3: '#0F3764',
    onBlueColor4: '#003764',
    onDarkColor: '#202020',
    onGrayColor: '#FAFAFA',
    onGrayColor2: '#EFEFEF',
    gapLinkColor: '#0A5694',
    gapDarkGray: '#666666',
    atLinkColor: '#2A71D4',
    grayColor3A: '#3A3A3A',
    whiteCreame: '#F6F4EB',
    darkBlue: '#000D42',
    grayD8: '#D8D9D6',
    black2A: '#2A2A2A',
    black2Balpha20: '#2B2B2B33',
    black2B: '#2B2B2B',
    brGrayColor3: '#2D2925',
    brDarkGray2: '#4D4D4D',
    grayColor2c28: '#2c282433',
};

var themeBrNewRedesign = function (theme, isQuickAddRedesignEnabled) {
    var redesignThemeBr = "\n      border-color: " + colorMap$1.brLightColor2 + ";\n      font-weight: " + theme.font.secondary.fontWeight + ";";
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? redesignThemeBr : '';
};
var atSelectedVariantNewRedesign = function (theme, isQuickAddRedesignEnabled) {
    var redesignThemeAt = "\n    &.selected > label {\n      font-size: 0.875rem;\n    }\n    &.selected::after {\n      background-color: " + colorMap$1.blackColor1 + ";\n      content: '';\n      display: block;\n      width: 100%;\n      height: 0.125rem;\n      border-radius: 0.75rem;\n    };";
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? redesignThemeAt : '';
};
var onSelectedVariantNewRedesign = function (theme, isQuickAddRedesignEnabled) {
    var onSelectedVariantStyles = "\n    &.selected {\n      border-bottom-width: 1px;\n      border-bottom-color: " + colorMap$1.onBlueColor2 + ";\n    }\n    &.selected > label {\n      font-weight: " + getFontWeight('medium').fontWeight + ";\n    }";
    return theme.isNewRedesign || isQuickAddRedesignEnabled
        ? onSelectedVariantStyles
        : "color: " + theme.color.wh + "; border-color: " + theme.color.g1 + ";";
};
var gapSelectedVariantNewRedesign = function (theme, isQuickAddRedesignEnabled) {
    var gaptSelectedVariantStyles = "\n    &.selected {\n      border-bottom-width: 1px;\n      border-bottom-color: " + theme.color.b1 + ";\n    }\n  ";
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? gaptSelectedVariantStyles : "color: " + theme.color.b1 + ";";
};

function variantRadioStyles(theme, isQuickAddRedesignEnabled) {
    var linkOverride = function () { return "\n    a { \n      width: 100%;\n\n      &:visited,\n      &:active {\n        color: inherit;\n      }\n    }\n  "; };
    var variantLabelPadding = forBrands(theme, {
        default: function () { return '0.5em 0'; },
        gap: function () { return '0.7em 0 0.5em'; },
        gapfs: function () { return '0.7em 0 0.5em'; },
    });
    var borders = forBrands(theme, {
        default: function () { return "\n      &:nth-of-type(n + 2) {\n        border-left: 1px solid " + theme.color.g4 + ";\n      }\n    "; },
        on: function () { return "\n      border-color: " + theme.color.b1 + ";\n      border-style: solid;\n      border-width: 1px 0;\n\n      &:first-of-type {\n        border-left-width: 1px;\n      }\n\n      &:nth-of-type(n + 2) {\n        border-left-width: 1px;\n      }\n\n      &:last-of-type {\n        border-right-width: 1px;\n      }\n    "; },
    });
    var selectedBackground = forBrands(theme, {
        gap: function () { return theme.color.g4; },
        gapfs: function () { return theme.color.g4; },
        brfs: function () { return theme.color.g1; },
        on: function () { return theme.color.g1; },
        at: function () { return theme.color.g5; },
    });
    var selectedFont = forBrands(theme, {
        gap: function () { return theme.font.secondary; },
        gapfs: function () { return theme.font.secondary; },
        on: function () { return theme.font.secondary; },
        at: function () { return theme.font.secondary; },
    });
    var focus = forBrands(theme, {
        gap: gapSelectedVariantNewRedesign(theme, isQuickAddRedesignEnabled),
        gapfs: gapSelectedVariantNewRedesign(theme, isQuickAddRedesignEnabled),
        br: function () { return "color: " + theme.color.wh + ";\n      background-color: " + theme.color.b1 + ";\n      position: relative;\n\n      &::before {\n        content: '';\n        width: 100%;\n        height: 100%;\n        top: -1px;\n        left: -1px;\n        position: absolute;\n        background: transparent;\n      }\n\n      &.selected {\n        " + themeBrNewRedesign(theme, isQuickAddRedesignEnabled) + "\n      }; \n      " + linkOverride + "\n    "; },
        brfs: function () { return "color: " + theme.color.wh + ";\n      background-color: " + theme.color.b1 + ";\n      position: relative;\n\n      &::before {\n        content: '';\n        width: 100%;\n        height: 100%;\n        top: -1px;\n        left: -1px;\n        position: absolute;\n        background: transparent;\n      }\n      \n      &.selected {\n        " + themeBrNewRedesign(theme, isQuickAddRedesignEnabled) + "; \n      }\n      " + linkOverride; },
        on: onSelectedVariantNewRedesign(theme, isQuickAddRedesignEnabled),
        at: atSelectedVariantNewRedesign(theme, isQuickAddRedesignEnabled),
    });
    return css(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n    text-transform: uppercase;\n    text-align: center;\n    cursor: pointer;\n    ", "\n    padding: ", ";\n    ", "\n    ", "\n\n    &.selected {\n      ", "\n      background-color: ", ";\n      ", "\n    }\n\n    .pillbox--2-across & {\n      width: 50%;\n    }\n\n    .pillbox--3-across & {\n      width: 33.33333%;\n    }\n\n    .pillbox--4-across & {\n      width: 25%;\n    }\n\n    & a {\n      display: block;\n    }\n\n    & .pdp-variant__radio {\n      ", "\n    }\n  "], ["\n    text-transform: uppercase;\n    text-align: center;\n    cursor: pointer;\n    ", "\n    padding: ", ";\n    ", "\n    ", "\n\n    &.selected {\n      ", "\n      background-color: ", ";\n      ", "\n    }\n\n    .pillbox--2-across & {\n      width: 50%;\n    }\n\n    .pillbox--3-across & {\n      width: 33.33333%;\n    }\n\n    .pillbox--4-across & {\n      width: 25%;\n    }\n\n    & a {\n      display: block;\n    }\n\n    & .pdp-variant__radio {\n      ", "\n    }\n  "])), theme.font.primary, variantLabelPadding, borders, sdsHeadingE(theme), focus, selectedBackground, selectedFont, theme.utilities.focusableHide);
}
var templateObject_1$8;

var marginNewRedesign = function (theme, isQuickAddRedesignEnabled) {
    var margin = forBrands(theme, {
        at: function () { return 'margin: 0 1.015rem'; },
        default: function () { return 'margin-right: 1.75rem'; },
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? margin : 'margin-right: 1.75rem';
};
var colorNewRedesign = function (theme, isQuickAddRedesignEnabled) {
    var color = forBrands(theme, {
        at: colorMap$1.blackColor1,
        on: colorMap$1.onBlueColor,
        gap: theme.color.b1,
        gapfs: theme.color.b1,
        default: theme.color.b1,
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? color : theme.color.b1;
};
var colorSelectedNewRedesign = function (theme, isQuickAddRedesignEnabled) {
    var color = forBrands(theme, {
        at: colorMap$1.blackColor1,
        on: colorMap$1.onBlueColor2,
        gap: theme.color.b1,
        gapfs: theme.color.b1,
        default: theme.color.b1,
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? color : theme.color.b1;
};
var borderColorNewRedesign = function (theme, isQuickAddRedesignEnabled) {
    var borderColor = forBrands(theme, {
        at: '',
        default: "border-color: " + theme.color.b1,
    });
    return theme.isNewRedesign || isQuickAddRedesignEnabled ? borderColor : "border-color: " + theme.color.b1;
};

var variantRadioAlternativeStyles = function (isNewBrFontEnabled, isQuickAddRedesignEnabled) { return function (theme) {
    var defaultVariantStyles = {
        fontSize: isNewBrFontEnabled ? '1rem' : '0.875rem',
        letterSpacing: 'auto',
    };
    var defaultForOtherBrands = {
        fontSize: '1rem',
        letterSpacing: 'auto',
    };
    var brNotSelected = __assign(__assign(__assign({}, theme.font.primary), defaultVariantStyles), { letterSpacing: '1px' });
    var variantFontPrimaryStyles = forBrands(theme, {
        br: brNotSelected,
        brfs: brNotSelected,
        default: defaultForOtherBrands,
    });
    var brNewFontUpdates = __assign(__assign({}, theme.font.primary), defaultVariantStyles);
    var defaultWithFontSecondary = __assign(__assign({}, theme.font.secondary), defaultForOtherBrands);
    var variantFontSecondaryStyles = forBrands(theme, {
        br: isNewBrFontEnabled ? brNewFontUpdates : defaultWithFontSecondary,
        brfs: isNewBrFontEnabled ? brNewFontUpdates : defaultWithFontSecondary,
        default: defaultWithFontSecondary,
    });
    return css(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n    display: inline-block;\n    color: ", ";\n    ", "\n    ", ";\n    padding: 0.25rem 0 0;\n    width: auto;\n    border: none;\n    border-bottom: 3px solid;\n    border-color: ", ";\n\n    &:nth-of-type(n + 2) {\n      border-left: none;\n    }\n\n    &.selected {\n      ", "\n      ", ";\n      color: ", ";\n      background-color: transparent;\n    }\n\n    & .pdp-variant__radio + .pdp-variant__label {\n      position: relative;\n      display: inline-block;\n    }\n\n    & .pdp-variant__radio.focus-visible + .pdp-variant__label {\n      outline: 0;\n      box-shadow: 0 0 0 3px ", ";\n    }\n  "], ["\n    display: inline-block;\n    color: ", ";\n    ", "\n    ", ";\n    padding: 0.25rem 0 0;\n    width: auto;\n    border: none;\n    border-bottom: 3px solid;\n    border-color: ", ";\n\n    &:nth-of-type(n + 2) {\n      border-left: none;\n    }\n\n    &.selected {\n      ", "\n      ", ";\n      color: ", ";\n      background-color: transparent;\n    }\n\n    & .pdp-variant__radio + .pdp-variant__label {\n      position: relative;\n      display: inline-block;\n    }\n\n    & .pdp-variant__radio.focus-visible + .pdp-variant__label {\n      outline: 0;\n      box-shadow: 0 0 0 3px ", ";\n    }\n  "])), colorNewRedesign(theme, isQuickAddRedesignEnabled), variantFontPrimaryStyles, marginNewRedesign(theme, isQuickAddRedesignEnabled), theme.color.wh, variantFontSecondaryStyles, borderColorNewRedesign(theme, isQuickAddRedesignEnabled), colorSelectedNewRedesign(theme, isQuickAddRedesignEnabled), theme.crossBrand.color.b2);
}; };
var templateObject_1$9;

function quickAddStyles$1() {
    return css(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n    font-size: 0.7rem;\n  "], ["\n    font-size: 0.7rem;\n  "])));
}
var templateObject_1$a;

function shouldRenderVariants(variants) {
    var variantCount = variants.length;
    return ((variantCount > 1 && variantCount < 5) || // Only render variants if there are less than 5
        (variantCount === 1 && variants[0].id !== 1) // If the only variant is Regular, don't render it
    );
}

function variantGroupStyles(theme, isQuickAddRedesignEnabled) {
    var gapStylesAlignCenter = "\n    display: flex;\n    justify-content: center;\n\n    .pdp-variant {\n      margin: 0 0.875rem 0;\n    }\n  ";
    var redesignStyles = forBrands(theme, {
        gap: theme.isNewRedesign || isQuickAddRedesignEnabled ? gapStylesAlignCenter : 'margin-left: 0.5rem;',
        gapfs: theme.isNewRedesign || isQuickAddRedesignEnabled ? gapStylesAlignCenter : 'margin-left: 0.5rem;',
        default: 'margin-left: 0.5rem;',
    });
    return css(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n    margin-bottom: 1rem;\n    ", "\n\n    & .radio-container__label {\n      ", "\n    }\n  "], ["\n    margin-bottom: 1rem;\n    ", "\n\n    & .radio-container__label {\n      ", "\n    }\n  "])), redesignStyles, visuallyHide());
}
var templateObject_1$b;

var VariantGroup = function (props) {
    var brand = useAppState$1().brandName;
    var _a = props.brandName, brandName = _a === void 0 ? brand : _a, pid = props.pid, variants = props.variants, _b = props.selectedVariant, selectedVariant = _b === void 0 ? { id: null } : _b, dispatch = props.dispatch, isQuickAddRedesignEnabled = props.isQuickAddRedesignEnabled, htmlProps = __rest(props, ["brandName", "pid", "variants", "selectedVariant", "dispatch", "isQuickAddRedesignEnabled"]);
    var localize = useLocalize().localize;
    var variantGroupLabel = localize('quickAdd.variantGroupLabel');
    var enabledFeatures = useContext(FeatureFlagsContext).enabledFeatures;
    var abbrBrand = brandName || brand;
    var newFontFeatureFlag = isBananaRepublic(abbrBrand) ? 'enable-new-br-fonts' : '';
    var isNewBrFontEnabled = enabledFeatures[newFontFeatureFlag];
    if (!shouldRenderVariants(variants)) {
        return null;
    }
    return (jsx("div", { "aria-labelledby": "swatch-label--Variant", css: function (theme) { return variantGroupStyles(theme, isQuickAddRedesignEnabled); }, role: "radiogroup" },
        jsx("span", { className: "radio-container__label", id: "swatch-label--Variant" }, variantGroupLabel),
        variants.map(function (variant) {
            var id = pid + "-variant-radio-" + variant.id;
            return (jsx(VariantRadio, __assign({ key: variant.name, css: function (theme) { return css(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n              ", "\n              ", "\n              ", "\n            "], ["\n              ", "\n              ", "\n              ", "\n            "])), variantRadioStyles(theme, isQuickAddRedesignEnabled), variantRadioAlternativeStyles(isNewBrFontEnabled, isQuickAddRedesignEnabled)(theme), quickAddStyles$1()); }, id: id, onChange: function () {
                    dispatch({
                        type: VARIANT_CHANGE,
                        payload: { variant: variant },
                    });
                }, selected: variant.id === selectedVariant.id, variant: variant }, htmlProps)));
        })));
};
var VariantGroup$1 = memo(VariantGroup);
var templateObject_1$c;

var sizeSelectorStyles = function (theme, gothamFontEnabled, isQuickAddRedesignEnabled) {
    var fontColor = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? "color: " + theme.color.b2 : '',
        brfs: isQuickAddRedesignEnabled ? "color: " + theme.color.b2 : '',
        default: '',
    });
    var border = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? "border: none" : '',
        brfs: isQuickAddRedesignEnabled ? "border: none" : '',
        default: '',
    });
    var selectedBorderBottom = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? "border-bottom: 3px solid" : '',
        brfs: isQuickAddRedesignEnabled ? "border-bottom: 3px solid" : '',
        default: '',
    });
    var selectedBorderColor = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? "border-color: " + theme.color.b2 : '',
        brfs: isQuickAddRedesignEnabled ? "border-color: " + theme.color.b2 : '',
        default: '',
    });
    var selectedFontWeight = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? 'font-weight: 600' : 'font-weight: 400',
        brfs: isQuickAddRedesignEnabled ? 'font-weight: 600' : 'font-weight: 400',
        default: '',
    });
    var fontSize = forBrands(theme, {
        at: isQuickAddRedesignEnabled ? '0.875rem' : '1rem',
        gap: isQuickAddRedesignEnabled ? '0.875rem' : '1rem',
        gapfs: isQuickAddRedesignEnabled ? '0.875rem' : '1rem',
        default: '1rem',
    });
    return css(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n    width: 20.063rem;\n\n    .pdp-variant {\n      ", ";\n\n      &.selected.selected {\n        ", ";\n        ", ";\n        ", ";\n      }\n\n      &__label {\n        ", ";\n      }\n    }\n\n    * {\n      font-size: ", " !important;\n    }\n  "], ["\n    width: 20.063rem;\n\n    .pdp-variant {\n      ", ";\n\n      &.selected.selected {\n        ", ";\n        ", ";\n        ", ";\n      }\n\n      &__label {\n        ", ";\n      }\n    }\n\n    * {\n      font-size: ", " !important;\n    }\n  "])), border, selectedBorderBottom, selectedBorderColor, selectedFontWeight, fontColor, gothamFontEnabled ? '0.875rem' : fontSize);
};
var templateObject_1$d;

var SizeSelectorMemo = memo(function SizeSelector(_a) {
    var brandName = _a.brandName, dispatch = _a.dispatch, variants = _a.variants, selectedVariant = _a.selectedVariant, selectedDimensions = _a.selectedDimensions, outOfStockDimensions = _a.outOfStockDimensions, isQuickAddRedesignEnabled = _a.isQuickAddRedesignEnabled, pid = _a.pid;
    var enabledFeatures = useContext(FeatureFlagsContext).enabledFeatures;
    var gothamFontEnabled = enabledFeatures["enable-" + brandName + "-gotham-font"];
    return (jsx("div", { className: "quick-add-size-selector", css: function (theme) { return sizeSelectorStyles(theme, gothamFontEnabled, isQuickAddRedesignEnabled); } },
        jsx(VariantGroup$1, { brandName: brandName, dispatch: dispatch, isQuickAddRedesignEnabled: isQuickAddRedesignEnabled, pid: pid, selectedVariant: selectedVariant, variants: variants }),
        jsx(DimensionGroups, { brandName: brandName, dimensions: selectedVariant.dimensions, dispatch: dispatch, isQuickAddRedesignEnabled: isQuickAddRedesignEnabled, outOfStockDimensions: outOfStockDimensions, pid: pid, selectedDimensions: selectedDimensions })));
});

var headerStyles = css(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var imageStyles = css(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  float: left;\n  height: 163px;\n  margin: 0 0 38px 8px;\n  width: 124px;\n"], ["\n  float: left;\n  height: 163px;\n  margin: 0 0 38px 8px;\n  width: 124px;\n"])));
var productInfoStyles = function (theme) { return css(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  height: fit-content;\n  padding-left: 0.625rem;\n\n  .show-tertiary-font {\n    ", "\n  }\n"], ["\n  height: fit-content;\n  padding-left: 0.625rem;\n\n  .show-tertiary-font {\n    ",
    "\n  }\n"])), forBrands(theme, {
    br: function () { return theme.font.tertiary; },
    brfs: function () { return theme.font.tertiary; },
    default: function () { return theme.font.primary; },
})); };
var productTitleStyles = function (theme, isNewBrFontEnabled, isQuickAddRedesignEnabled) {
    var brStyles = forBrands(theme, {
        br: function () { return (isNewBrFontEnabled ? theme.font.tertiary : theme.font.secondary); },
        brfs: function () { return (isNewBrFontEnabled ? theme.font.tertiary : theme.font.secondary); },
        default: function () { return theme.font.secondary; },
    });
    var brTextColorStyles = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? theme.color.b2 : theme.color.b1,
        brfs: isQuickAddRedesignEnabled ? theme.color.b2 : theme.color.b1,
        default: theme.color.b1,
    });
    return css(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n    color: ", ";\n    display: block;\n    font-size: 1.125rem;\n    letter-spacing: 0.026rem;\n    line-height: 1.25rem;\n    margin-right: 0.125rem;\n    padding-top: 0.625rem;\n    text-align: left;\n    ", "\n  "], ["\n    color: ", ";\n    display: block;\n    font-size: 1.125rem;\n    letter-spacing: 0.026rem;\n    line-height: 1.25rem;\n    margin-right: 0.125rem;\n    padding-top: 0.625rem;\n    text-align: left;\n    ", "\n  "])), brTextColorStyles, brStyles);
};
var reviewWrapperStyles = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding-top: 10px;\n"], ["\n  display: flex;\n  align-items: center;\n  padding-top: 10px;\n"])));
var reviewCountStyles = function (theme, isNewBrFontEnabled, isQuickAddRedesignEnabled) {
    var textColor = forBrands(theme, {
        default: theme.color.bk,
        gap: theme.color.b2,
        gapfs: theme.color.b2,
        on: theme.color.b1,
        br: isQuickAddRedesignEnabled ? theme.color.b2 : theme.color.bk,
        brfs: isQuickAddRedesignEnabled ? theme.color.b2 : theme.color.bk,
    });
    var brFontWeightStyles = forBrands(theme, {
        br: function () { return (isNewBrFontEnabled ? '400' : 'bold'); },
        brfs: function () { return (isNewBrFontEnabled ? '400' : 'bold'); },
        default: function () { return 'bold'; },
    });
    var brRedesignFontWeightStyles = forBrands(theme, {
        br: 'bolder',
        brfs: 'bolder',
        default: 'bold',
    });
    var brRedesignMarginLeft = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? '-11px' : '6px',
        brfs: isQuickAddRedesignEnabled ? '-11px' : '6px',
        default: '6px',
    });
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    color: ", ";\n    font-size: 0.875rem;\n    font-weight: ", ";\n    margin-left: ", ";\n  "], ["\n    color: ", ";\n    font-size: 0.875rem;\n    font-weight: ", ";\n    margin-left: ", ";\n  "])), textColor, isQuickAddRedesignEnabled ? brRedesignFontWeightStyles : brFontWeightStyles, brRedesignMarginLeft);
};
var colorNameStyles = function (theme, isNewBrFontEnabled, isQuickAddRedesignEnabled) {
    var brFontWeightStyles = forBrands(theme, {
        br: function () { return (isNewBrFontEnabled ? 'font-weight: 400;' : ''); },
        brfs: function () { return (isNewBrFontEnabled ? 'font-weight: 400;' : ''); },
    });
    var brTextColorStyles = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? theme.color.b2 : theme.color.gray80,
        brfs: isQuickAddRedesignEnabled ? theme.color.b2 : theme.color.gray80,
        default: theme.color.gray80,
    });
    return css(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n    color: ", ";\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n    padding-top: 0.4375rem;\n    ", "\n    .color-label {\n      font-weight: ", ";\n    }\n  "], ["\n    color: ", ";\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n    padding-top: 0.4375rem;\n    ", "\n    .color-label {\n      font-weight: ", ";\n    }\n  "])), brTextColorStyles, brFontWeightStyles, isNewBrFontEnabled ? '400' : '700');
};
var templateObject_1$e, templateObject_2$5, templateObject_3$3, templateObject_4$2, templateObject_5, templateObject_6, templateObject_7$2;

/** @jsx jsx */
var ProductInfoHeader = function (_a) {
    var brandName = _a.brandName, productURL = _a.productURL, data = _a.data, reviews = _a.reviews, isQuickAddRedesignEnabled = _a.isQuickAddRedesignEnabled, isProductRedirectDisabled = _a.isProductRedirectDisabled;
    var localize = useLocalize().localize;
    var enabledFeatures = useContext(FeatureFlagsContext).enabledFeatures;
    var colorName = data.colorName, mainImage = data.mainImage, name = data.name;
    var _b = reviews.reviewCount, reviewCount = _b === void 0 ? 0 : _b, _c = reviews.starRating, starRating = _c === void 0 ? 0 : _c;
    var colorLabel = localize('quickAdd.colorLabel');
    var tertiaryFontEnabled = enabledFeatures[brandName + "-tertiary-font"];
    var fontClass = tertiaryFontEnabled ? 'show-tertiary-font' : '';
    var ratingsLabel = localize(reviewCount === 1 ? 'fui.ReviewRatings.singularLabel' : 'fui.ReviewRatings.pluralLabel', { reviewCount: reviewCount });
    var reviewRatingsAriaLabel = localize(reviewCount === 0 ? 'fui.ReviewRatings.ariaLabelNoReviews' : 'fui.ReviewRatings.ariaLabel', { starRating: starRating });
    var brFontFeatureFlag = isBananaRepublic(brandName) ? 'enable-new-br-fonts' : '';
    var brFontEnabled = enabledFeatures[brFontFeatureFlag];
    var reviewCountInnerHtml = isQuickAddRedesignEnabled ? "" + reviewCount : "(" + reviewCount + ")";
    var productImage = !isProductRedirectDisabled ? (jsx("a", { css: imageStyles, href: productURL },
        jsx("img", { alt: name, "data-testid": "imageContainer", src: mainImage.medium }))) : (jsx("div", { css: imageStyles },
        jsx("img", { alt: name, "data-testid": "imageContainer", src: mainImage.medium })));
    var productTitle = !isProductRedirectDisabled ? (jsx("a", { className: fontClass, css: function (theme) { return productTitleStyles(theme, brFontEnabled, isQuickAddRedesignEnabled); }, href: productURL },
        jsx("h2", { dangerouslySetInnerHTML: { __html: name }, id: "quick-add-product-title" }))) : (jsx("div", { className: fontClass, css: function (theme) { return productTitleStyles(theme, brFontEnabled, isQuickAddRedesignEnabled); } },
        jsx("h2", { dangerouslySetInnerHTML: { __html: name }, id: "quick-add-product-title" })));
    return (jsx("div", { className: "quick-add__header", css: headerStyles },
        jsx("div", { className: "quick-add__product-image" }, productImage),
        jsx("div", { className: "quick-add__product-info", css: productInfoStyles },
            productTitle,
            jsx("div", { className: "quick-add_review-ratings", css: reviewWrapperStyles },
                jsx(StitchInverseStyleProvider, { invert: false },
                    jsx(ReviewRatings, { ariaLabel: reviewRatingsAriaLabel, starRating: starRating, tabIndex: -1 })),
                jsx("span", { "aria-label": ratingsLabel, css: function (theme) { return reviewCountStyles(theme, brFontEnabled, isQuickAddRedesignEnabled); }, "data-testid": "review-count" }, reviewCount > 0 ? reviewCountInnerHtml : '')),
            jsx("div", { className: "quick-add__color-name", css: function (theme) { return colorNameStyles(theme, brFontEnabled, isQuickAddRedesignEnabled); } },
                jsx("span", { className: "color-label" },
                    colorLabel,
                    ": "),
                jsx("span", { className: fontClass, dangerouslySetInnerHTML: { __html: colorName } })))));
};

var containerStyles = css(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"])));
var dimensionsContainerStyles = css(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  flex-direction: column;\n  display: flex;\n  justify-content: space-between;\n  padding: 0 0.5rem 0.5rem 0.5rem;\n  min-height: 21.5rem;\n"], ["\n  flex-direction: column;\n  display: flex;\n  justify-content: space-between;\n  padding: 0 0.5rem 0.5rem 0.5rem;\n  min-height: 21.5rem;\n"])));
var templateObject_1$f, templateObject_2$6;

var messageFlagStyles = function (theme, isNewBrFontEnabled, isQuickAddRedesignEnabled) {
    var brFontWeightStyles = forBrands(theme, {
        br: function () { return (isNewBrFontEnabled ? 'font-weight: 400' : ''); },
        brfs: function () { return (isNewBrFontEnabled ? 'font-weight: 400' : ''); },
    });
    var brColorStyles = forBrands(theme, {
        br: isQuickAddRedesignEnabled ? theme.color.b2 : theme.color.gray80,
        brfs: isQuickAddRedesignEnabled ? theme.color.b2 : theme.color.gray80,
        default: theme.color.gray80,
    });
    return css(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n    text-align: center;\n    color: ", ";\n    font-size: 0.875rem;\n    line-height: 1.0625rem;\n    padding: 0.125rem 0.5rem 0.3125rem 0.5rem;\n    ", ";\n  "], ["\n    text-align: center;\n    color: ", ";\n    font-size: 0.875rem;\n    line-height: 1.0625rem;\n    padding: 0.125rem 0.5rem 0.3125rem 0.5rem;\n    ", ";\n  "])), brColorStyles, brFontWeightStyles);
};
var templateObject_1$g;

var QuickAddMarketFlag = function (props) {
    var messageFlag = props.messageFlag, isNewBrFontEnabled = props.isNewBrFontEnabled, isQuickAddRedesignEnabled = props.isQuickAddRedesignEnabled;
    return (jsx("div", { className: "quick-add__marketing-flag", css: function (theme) { return messageFlagStyles(theme, isNewBrFontEnabled, isQuickAddRedesignEnabled); } }, messageFlag));
};

var dropShipStyles = function () {
    return css(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n    text-align: center;\n    margin: 0.5rem;\n  "], ["\n    text-align: center;\n    margin: 0.5rem;\n  "])));
};
var templateObject_1$h;

var QuickAddDropshipFlag = function (props) {
    var messageFlag = props.messageFlag;
    return (jsx("ul", { css: dropShipStyles }, messageFlag === null || messageFlag === void 0 ? void 0 : messageFlag.map(function (flag) { return (jsx("li", { key: flag }, flag)); })));
};

/** @jsx jsx */
var buildProductPageURL = function (selectedSku, pid) {
    var productID = selectedSku ? selectedSku.skuId : pid;
    return "/browse/product.do?pid=" + productID + "#pdp-page-content";
};
function QuickAddContainerWithProductInfo(_a) {
    var addToBagUrls = _a.addToBagUrls, clientId = _a.clientId, data = _a.data, onAddToBag = _a.onAddToBag, enableLegacyAddToBag = _a.enableLegacyAddToBag, pid = _a.pid, locale = _a.locale, brandName = _a.brandName, powerReviewsConfig = _a.powerReviewsConfig, reviews = _a.reviews, reportQuickAddStart = _a.reportQuickAddStart, errorLogger = _a.errorLogger, isDropShipEnabled = _a.isDropShipEnabled, isQuickAddRedesignEnabled = _a.isQuickAddRedesignEnabled, isProductRedirectDisabled = _a.isProductRedirectDisabled;
    var enabledFeatures = useContext(FeatureFlagsContext).enabledFeatures;
    var nonMergedVariants = getRegularVariants(data.variants);
    var inStockVariants = nonMergedVariants.filter(isVariantInStock);
    var _b = useReducer(quickAddReducer, inStockVariants, initQuickAddState), state = _b[0], dispatch = _b[1];
    var marketingFlag = data.marketingFlag, name = data.name, price = data.price, isGiftCard = data.isGiftCard;
    var inProgress = state.inProgress, outOfStockDimensions = state.outOfStockDimensions, response = state.response, selectedDimensions = state.selectedDimensions, selectedSku = state.selectedSku, selectedVariant = state.selectedVariant, unselectedDimensions = state.unselectedDimensions;
    var productURL = buildProductPageURL(selectedSku, pid);
    var powerReviewsAllLocaleEnabled = enabledFeatures['pdp-power-reviews-all-locale'];
    var reviewsResponse = useReviewRatings({
        pid: pid,
        locale: locale,
        powerReviewsConfig: powerReviewsConfig,
        reviews: reviews,
        powerReviewsAllLocaleEnabled: powerReviewsAllLocaleEnabled,
    });
    var brFontFeatureFlag = isBananaRepublic(brandName) ? 'enable-new-br-fonts' : '';
    var isNewBrFontEnabled = enabledFeatures[brFontFeatureFlag];
    var localize = useLocalize().localize;
    var isDropShip = data.isDropShip, excludedFromPromotions = data.excludedFromPromotions;
    var excludedFromPromotionsOrMarketingFlag = useCallback(function () {
        if (isDropShip && isDropShipEnabled && isQuickAddRedesignEnabled && excludedFromPromotions) {
            var excludedFromPromotionsCopy = localize('quickAdd.excludedFromPromotions');
            return jsx(QuickAddDropshipFlag, { messageFlag: [excludedFromPromotionsCopy] });
        }
        if (marketingFlag) {
            return (jsx(QuickAddMarketFlag, { isNewBrFontEnabled: isNewBrFontEnabled, isQuickAddRedesignEnabled: isQuickAddRedesignEnabled, messageFlag: marketingFlag }));
        }
    }, []);
    useEffect(function () {
        reportQuickAddStart(selectedVariant);
        // DO NOT ADD DEPENDENCIES TO THE DEPS ARRAY
        // This is supposed to run only when the component mounts
    }, []);
    return (jsx("div", { css: containerStyles, "data-testid": "withProductInfo" },
        jsx(ProductInfoHeader, { brandName: brandName, data: data, isProductRedirectDisabled: isProductRedirectDisabled, isQuickAddRedesignEnabled: isQuickAddRedesignEnabled, productURL: productURL, reviews: reviewsResponse }),
        jsx("div", { css: dimensionsContainerStyles },
            jsx(SizeSelectorMemo, { brandName: brandName, dispatch: dispatch, isQuickAddRedesignEnabled: isQuickAddRedesignEnabled, outOfStockDimensions: outOfStockDimensions, pid: pid, selectedDimensions: selectedDimensions, selectedVariant: selectedVariant, variants: inStockVariants }),
            jsx(AddToBag, { addToBagUrls: addToBagUrls, brandName: brandName, clientId: clientId, dispatch: dispatch, enableLegacyAddToBag: enableLegacyAddToBag, errorLogger: errorLogger, inProgress: inProgress, isGiftCard: isGiftCard, isQuickAddRedesignEnabled: isQuickAddRedesignEnabled, name: name, onAddToBag: onAddToBag, pid: pid, price: price, response: response, selectedDimensions: selectedDimensions, selectedSku: selectedSku, unselectedDimensions: unselectedDimensions })),
        excludedFromPromotionsOrMarketingFlag()));
}

/**
 * Build url according to the provided path and query
 * @param {String} base - can be an host or static url with protocal e.g. https://api.test.com or http://api.gap.com/ux/etc ..
 * @param {Object} queryPrams - an object contains the query key - value pair.
 * @param {String} pathPattern - string pattern for url path part, use {index} as the placeholder if you need to replace it with pathParams
 * @param {Array} pathParams - A string array to use to replace the corresponding placeholder in pathPattern.
 * @returns {String} - the output URL
 */
var buildURL = function (_a) {
    var base = _a.base, _b = _a.queryParams, queryParams = _b === void 0 ? {} : _b, pathPattern = _a.pathPattern, _c = _a.pathParams, pathParams = _c === void 0 ? [] : _c;
    var endpoint = new URL(base);
    Object.entries(queryParams).forEach(function (_a) {
        var key = _a[0], val = _a[1];
        endpoint.searchParams.set(key, val);
    });
    var path = pathPattern;
    if (pathParams.length > 0) {
        pathParams.forEach(function (item, index) {
            path = path === null || path === void 0 ? void 0 : path.split("{" + index + "}").join(item);
        });
    }
    if (!(path === null || path === void 0 ? void 0 : path.startsWith('/'))) {
        path = "/" + path;
    }
    if (endpoint.pathname === '/') {
        endpoint.pathname = path;
    }
    else {
        endpoint.pathname = "" + endpoint.pathname + path;
    }
    return endpoint.href;
};

var useProductStyle = function (productStyleParams) {
    var pid = productStyleParams.pid, brand = productStyleParams.brand, market = productStyleParams.market, country = productStyleParams.country, contentType = productStyleParams.contentType, locale = productStyleParams.locale, apiConfig = productStyleParams.apiConfig, pssUrl = productStyleParams.pssUrl;
    var apikey = apiConfig.pssApiKey;
    var endpoint = buildURL({
        base: pssUrl,
        queryParams: {
            brand: brand === null || brand === void 0 ? void 0 : brand.toUpperCase(),
            market: market === null || market === void 0 ? void 0 : market.toUpperCase(),
            country: country === null || country === void 0 ? void 0 : country.toUpperCase(),
            locale: locale,
            colorLevel: true,
            requestType: contentType,
        },
        pathPattern: '/product-styles/{0}',
        pathParams: [pid],
    });
    return useFetch(endpoint, {
        headers: {
            apikey: apikey,
        },
    });
};

var quickAddStyles$2 = css(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding-top: 2.5rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding-top: 2.5rem;\n"])));
var templateObject_1$i;

var shortenFrenchLabels = function (data) { return (__assign(__assign({}, data), { variants: data === null || data === void 0 ? void 0 : data.variants.map(function (v) {
        if (v.name.toLowerCase() !== 'grandes tailles') {
            return v;
        }
        return __assign(__assign({}, v), { name: 'Grandes' });
    }) })); };

var brandCodeUrls = {
	us: {
		gap: {
			secureUrl: "https://secure-www.gap.com",
			oidcUrl: "https://api.gap.com",
			productStyleService: "https://api.gap.com/ux/web/product-style-web-experience"
		},
		br: {
			secureUrl: "https://secure-bananarepublic.gap.com",
			oidcUrl: "https://api.gap.com",
			productStyleService: "https://api.gap.com/ux/web/product-style-web-experience"
		},
		on: {
			secureUrl: "https://secure-oldnavy.gap.com",
			oidcUrl: "https://api.gap.com",
			productStyleService: "https://api.gap.com/ux/web/product-style-web-experience"
		},
		at: {
			secureUrl: "https://secure-athleta.gap.com",
			oidcUrl: "https://api.gap.com",
			productStyleService: "https://api.gap.com/ux/web/product-style-web-experience"
		},
		gapfs: {
			secureUrl: "https://secure-www.gapfactory.com",
			oidcUrl: "https://api.gapfactory.com",
			productStyleService: "https://api.gapfactory.com/ux/web/product-style-web-experience"
		},
		brfs: {
			secureUrl: "https://secure-bananarepublicfactory.gapfactory.com",
			oidcUrl: "https://api.gapfactory.com",
			productStyleService: "https://api.gapfactory.com/ux/web/product-style-web-experience"
		}
	},
	ca: {
		gap: {
			secureUrl: "https://secure-www.gapcanada.ca",
			oidcUrl: "https://api.gapcanada.ca",
			productStyleService: "https://api.gap.com/ux/web/product-style-web-experience"
		},
		br: {
			secureUrl: "https://secure-bananarepublic.gapcanada.ca",
			oidcUrl: "https://api.gapcanada.ca",
			productStyleService: "https://api.gapcanada.ca/ux/web/product-style-web-experience"
		},
		on: {
			secureUrl: "https://secure-oldnavy.gapcanada.ca",
			oidcUrl: "https://api.gapcanada.ca",
			productStyleService: "https://api.gapcanada.ca/ux/web/product-style-web-experience"
		},
		at: {
			secureUrl: "https://secure-athleta.gapcanada.ca",
			oidcUrl: "https://api.gapcanada.ca",
			productStyleService: "https://api.gapcanada.ca/ux/web/product-style-web-experience"
		}
	}
};
var powerReviewsConfig = {
	en_US: {
		gap: {
			groupId: 524780421,
			merchantId: 1443032450,
			apiKey: "96e4b93c-348e-4f21-847b-028497ff9f1c"
		},
		on: {
			groupId: 524780421,
			merchantId: 650520397,
			apiKey: "96e4b93c-348e-4f21-847b-028497ff9f1c"
		},
		br: {
			groupId: 524780421,
			merchantId: 911560314,
			apiKey: "96e4b93c-348e-4f21-847b-028497ff9f1c"
		},
		at: {
			groupId: 524780421,
			merchantId: 1367436744,
			apiKey: "96e4b93c-348e-4f21-847b-028497ff9f1c"
		},
		gapfs: {
			groupId: 160838694,
			merchantId: 1109823159,
			apiKey: "953904b2-06b6-4861-8eae-fd73f81ff303"
		},
		brfs: {
			groupId: 160838694,
			merchantId: 1516339149,
			apiKey: "953904b2-06b6-4861-8eae-fd73f81ff303"
		}
	},
	en_CA: {
		gap: {
			groupId: 1373651604,
			merchantId: 149259715,
			apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
		},
		on: {
			groupId: 1373651604,
			merchantId: 30636116,
			apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
		},
		br: {
			groupId: 1373651604,
			merchantId: 674040222,
			apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
		},
		at: {
			groupId: 1373651604,
			merchantId: 654468223,
			apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
		}
	},
	fr_CA: {
		gap: {
			groupId: 1373651604,
			merchantId: 1522080150,
			apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
		},
		on: {
			groupId: 1373651604,
			merchantId: 1954404204,
			apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
		},
		br: {
			groupId: 1373651604,
			merchantId: 1362840637,
			apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
		},
		at: {
			groupId: 1373651604,
			merchantId: 1774256798,
			apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
		}
	}
};
var productStyleService = "https://api.gap.com/ux/web/product-style-web-experience";
var defaultConfigs = {
	brandCodeUrls: brandCodeUrls,
	powerReviewsConfig: powerReviewsConfig,
	productStyleService: productStyleService
};

var brandCodeUrls$1 = {
	us: {
		gap: {
			secureUrl: "https://secure-www.gap.com",
			oidcUrl: "https://api.gap.com",
			productStyleService: "https://api.gap.com/ux/web/product-style-web-experience"
		},
		br: {
			secureUrl: "https://secure-bananarepublic.gap.com",
			oidcUrl: "https://api.gap.com",
			productStyleService: "https://api.gap.com/ux/web/product-style-web-experience"
		},
		on: {
			secureUrl: "https://secure-oldnavy.gap.com",
			oidcUrl: "https://api.gap.com",
			productStyleService: "https://api.gap.com/ux/web/product-style-web-experience"
		},
		at: {
			secureUrl: "https://secure-athleta.gap.com",
			oidcUrl: "https://api.gap.com",
			productStyleService: "https://api.gap.com/ux/web/product-style-web-experience"
		},
		gapfs: {
			secureUrl: "https://secure-www.gapfactory.com",
			oidcUrl: "https://api.gapfactory.com",
			productStyleService: "https://api.gapfactory.com/ux/web/product-style-web-experience"
		},
		brfs: {
			secureUrl: "https://secure-bananarepublicfactory.gapfactory.com",
			oidcUrl: "https://api.gapfactory.com",
			productStyleService: "https://api.gapfactory.com/ux/web/product-style-web-experience"
		}
	},
	ca: {
		gap: {
			secureUrl: "https://secure-www.gapcanada.ca",
			oidcUrl: "https://api.gapcanada.ca",
			productStyleService: "https://api.gapcanada.ca/ux/web/product-style-web-experience"
		},
		br: {
			secureUrl: "https://secure-bananarepublic.gapcanada.ca",
			oidcUrl: "https://api.gapcanada.ca",
			productStyleService: "https://api.gapcanada.ca/ux/web/product-style-web-experience"
		},
		on: {
			secureUrl: "https://secure-oldnavy.gapcanada.ca",
			oidcUrl: "https://api.gapcanada.ca",
			productStyleService: "https://api.gapcanada.ca/ux/web/product-style-web-experience"
		},
		at: {
			secureUrl: "https://secure-athleta.gapcanada.ca",
			oidcUrl: "https://api.gapcanada.ca",
			productStyleService: "https://api.gapcanada.ca/ux/web/product-style-web-experience"
		}
	}
};
var powerReviewsConfig$1 = {
	en_US: {
		gap: {
			groupId: 524780421,
			merchantId: 1443032450,
			apiKey: "96e4b93c-348e-4f21-847b-028497ff9f1c"
		},
		on: {
			groupId: 524780421,
			merchantId: 650520397,
			apiKey: "96e4b93c-348e-4f21-847b-028497ff9f1c"
		},
		br: {
			groupId: 524780421,
			merchantId: 911560314,
			apiKey: "96e4b93c-348e-4f21-847b-028497ff9f1c"
		},
		at: {
			groupId: 524780421,
			merchantId: 1367436744,
			apiKey: "96e4b93c-348e-4f21-847b-028497ff9f1c"
		},
		gapfs: {
			groupId: 160838694,
			merchantId: 1109823159,
			apiKey: "953904b2-06b6-4861-8eae-fd73f81ff303"
		},
		brfs: {
			groupId: 160838694,
			merchantId: 1516339149,
			apiKey: "953904b2-06b6-4861-8eae-fd73f81ff303"
		}
	},
	en_CA: {
		gap: {
			groupId: 1373651604,
			merchantId: 149259715,
			apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
		},
		on: {
			groupId: 1373651604,
			merchantId: 30636116,
			apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
		},
		br: {
			groupId: 1373651604,
			merchantId: 674040222,
			apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
		},
		at: {
			groupId: 1373651604,
			merchantId: 654468223,
			apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
		}
	},
	fr_CA: {
		gap: {
			groupId: 1373651604,
			merchantId: 1522080150,
			apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
		},
		on: {
			groupId: 1373651604,
			merchantId: 1954404204,
			apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
		},
		br: {
			groupId: 1373651604,
			merchantId: 1362840637,
			apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
		},
		at: {
			groupId: 1373651604,
			merchantId: 1774256798,
			apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
		}
	}
};
var productStyleService$1 = "https://api.gap.com/ux/web/product-style-web-experience";
var prod = {
	brandCodeUrls: brandCodeUrls$1,
	powerReviewsConfig: powerReviewsConfig$1,
	productStyleService: productStyleService$1
};

var brandCodeUrls$2 = {
	us: {
		gap: {
			secureUrl: "https://{{subdomain}}www.{{contentType}}test.{{domain}}.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.{{domain}}.com",
			productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
		},
		br: {
			secureUrl: "https://{{subdomain}}brol.{{contentType}}test.{{domain}}.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.{{domain}}.com",
			productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
		},
		on: {
			secureUrl: "https://{{subdomain}}onol.{{contentType}}test.{{domain}}.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.{{domain}}.com",
			productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
		},
		at: {
			secureUrl: "https://{{subdomain}}atol.{{contentType}}test.{{domain}}.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.{{domain}}.com",
			productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
		},
		gapfs: {
			secureUrl: "https://{{subdomain}}www.{{contentType}}test.factory-{{domain}}.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.factory-{{domain}}.com",
			productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
		},
		brfs: {
			secureUrl: "https://{{subdomain}}brfol.{{contentType}}test.factory-{{domain}}.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.factory-{{domain}}.com",
			productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
		}
	},
	ca: {
		gap: {
			secureUrl: "https://{{subdomain}}www.{{contentType}}test.{{domain}}.ca",
			oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.{{domain}}.ca",
			productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
		},
		br: {
			secureUrl: "https://{{subdomain}}brol.{{contentType}}test.{{domain}}.ca",
			oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.{{domain}}.ca",
			productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
		},
		on: {
			secureUrl: "https://{{subdomain}}onol.{{contentType}}test.{{domain}}.ca",
			oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.{{domain}}.ca",
			productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
		},
		at: {
			secureUrl: "https://{{subdomain}}atol.{{contentType}}test.{{domain}}.ca",
			oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.{{domain}}.ca",
			productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
		}
	}
};
var powerReviewsConfig$2 = {
	en_US: {
		gap: {
			groupId: 78519,
			merchantId: 651534,
			apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
		},
		on: {
			groupId: 78519,
			merchantId: 41628,
			apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
		},
		br: {
			groupId: 78519,
			merchantId: 377605,
			apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
		},
		at: {
			groupId: 78519,
			merchantId: 123756,
			apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
		},
		gapfs: {
			groupId: 80934,
			merchantId: 485459,
			apiKey: "491f2f5e-acd0-41e0-bbaf-3748f345f489"
		},
		brfs: {
			groupId: 80934,
			merchantId: 69585,
			apiKey: "491f2f5e-acd0-41e0-bbaf-3748f345f489"
		}
	},
	en_CA: {
		gap: {
			groupId: 80931,
			merchantId: 216454,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		on: {
			groupId: 80931,
			merchantId: 372736,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		br: {
			groupId: 80931,
			merchantId: 956586,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		at: {
			groupId: 80931,
			merchantId: 274124135,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		}
	},
	fr_CA: {
		gap: {
			groupId: 80931,
			merchantId: 70571,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		on: {
			groupId: 80931,
			merchantId: 202293,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		br: {
			groupId: 80931,
			merchantId: 38986,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		at: {
			groupId: 80931,
			merchantId: 1055652790,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		}
	}
};
var productStyleService$2 = "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience";
var test = {
	brandCodeUrls: brandCodeUrls$2,
	powerReviewsConfig: powerReviewsConfig$2,
	productStyleService: productStyleService$2
};

var brandCodeUrls$3 = {
	us: {
		gap: {
			secureUrl: "https://{{subdomain}}www.{{contentType}}stage.{{domain}}.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.com",
			productStyleService: "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience"
		},
		br: {
			secureUrl: "https://{{subdomain}}brol.{{contentType}}stage.{{domain}}.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.com",
			productStyleService: "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience"
		},
		on: {
			secureUrl: "https://{{subdomain}}onol.{{contentType}}stage.{{domain}}.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.com",
			productStyleService: "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience"
		},
		at: {
			secureUrl: "https://{{subdomain}}atol.{{contentType}}stage.{{domain}}.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.com",
			productStyleService: "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience"
		},
		gapfs: {
			secureUrl: "https://{{subdomain}}www.{{contentType}}stage.factory-{{domain}}.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.factory-{{domain}}.com",
			productStyleService: "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience"
		},
		brfs: {
			secureUrl: "https://{{subdomain}}brfol.{{contentType}}stage.factory-{{domain}}.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.factory-{{domain}}.com",
			productStyleService: "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience"
		}
	},
	ca: {
		gap: {
			secureUrl: "https://{{subdomain}}www.{{contentType}}stage.{{domain}}.ca",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.ca",
			productStyleService: "https://stage.api.azeus.gap.com/ux/web/product-style-web-experience"
		},
		br: {
			secureUrl: "https://{{subdomain}}brol.{{contentType}}stage.{{domain}}.ca",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.ca",
			productStyleService: "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience"
		},
		on: {
			secureUrl: "https://{{subdomain}}onol.{{contentType}}stage.{{domain}}.ca",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.ca",
			productStyleService: "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience"
		},
		at: {
			secureUrl: "https://{{subdomain}}atol.{{contentType}}stage.{{domain}}.ca",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.ca",
			productStyleService: "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience"
		}
	}
};
var powerReviewsConfig$3 = {
	en_US: {
		gap: {
			groupId: 78519,
			merchantId: 651534,
			apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
		},
		on: {
			groupId: 78519,
			merchantId: 41628,
			apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
		},
		br: {
			groupId: 78519,
			merchantId: 377605,
			apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
		},
		at: {
			groupId: 78519,
			merchantId: 123756,
			apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
		},
		gapfs: {
			groupId: 80934,
			merchantId: 485459,
			apiKey: "491f2f5e-acd0-41e0-bbaf-3748f345f489"
		},
		brfs: {
			groupId: 80934,
			merchantId: 69585,
			apiKey: "491f2f5e-acd0-41e0-bbaf-3748f345f489"
		}
	},
	en_CA: {
		gap: {
			groupId: 80931,
			merchantId: 216454,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		on: {
			groupId: 80931,
			merchantId: 372736,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		br: {
			groupId: 80931,
			merchantId: 956586,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		at: {
			groupId: 80931,
			merchantId: 274124135,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		}
	},
	fr_CA: {
		gap: {
			groupId: 80931,
			merchantId: 70571,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		on: {
			groupId: 80931,
			merchantId: 202293,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		br: {
			groupId: 80931,
			merchantId: 38986,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		at: {
			groupId: 80931,
			merchantId: 1055652790,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		}
	}
};
var productStyleService$3 = "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience";
var local = {
	brandCodeUrls: brandCodeUrls$3,
	powerReviewsConfig: powerReviewsConfig$3,
	productStyleService: productStyleService$3
};

var brandCodeUrls$4 = {
	us: {
		gap: {
			secureUrl: "https://secure.www.{{contentType}}prod.gaptecholapps.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.gaptecholapps.com",
			productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
		},
		br: {
			secureUrl: "https://secure.brol.{{contentType}}prod.gaptecholapps.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.gaptecholapps.com",
			productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
		},
		on: {
			secureUrl: "https://secure.onol.{{contentType}}prod.gaptecholapps.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.gaptecholapps.com",
			productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
		},
		at: {
			secureUrl: "https://secure.atol.{{contentType}}prod.gaptecholapps.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.gaptecholapps.com",
			productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
		},
		gapfs: {
			secureUrl: "https://secure.www.{{contentType}}prod.factory-gaptecholapps.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.factory-gaptecholapps.com",
			productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
		},
		brfs: {
			secureUrl: "https://secure.brfol.{{contentType}}prod.factory-gaptecholapps.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.factory-gaptecholapps.com",
			productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
		}
	},
	ca: {
		gap: {
			secureUrl: "https://secure.www.{{contentType}}prod.gaptecholapps.ca",
			oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.gaptecholapps.ca",
			productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
		},
		br: {
			secureUrl: "https://secure.brol.{{contentType}}prod.gaptecholapps.ca",
			oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.gaptecholapps.ca",
			productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
		},
		on: {
			secureUrl: "https://secure.onol.{{contentType}}prod.gaptecholapps.ca",
			oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.gaptecholapps.ca",
			productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
		},
		at: {
			secureUrl: "https://secure.atol.{{contentType}}prod.gaptecholapps.ca",
			oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.gaptecholapps.ca",
			productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
		}
	}
};
var powerReviewsConfig$4 = {
	en_US: {
		gap: {
			groupId: 78519,
			merchantId: 651534,
			apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
		},
		on: {
			groupId: 78519,
			merchantId: 41628,
			apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
		},
		br: {
			groupId: 78519,
			merchantId: 377605,
			apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
		},
		at: {
			groupId: 78519,
			merchantId: 123756,
			apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
		},
		gapfs: {
			groupId: 80934,
			merchantId: 485459,
			apiKey: "491f2f5e-acd0-41e0-bbaf-3748f345f489"
		},
		brfs: {
			groupId: 80934,
			merchantId: 69585,
			apiKey: "491f2f5e-acd0-41e0-bbaf-3748f345f489"
		}
	},
	en_CA: {
		gap: {
			groupId: 80931,
			merchantId: 216454,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		on: {
			groupId: 80931,
			merchantId: 372736,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		br: {
			groupId: 80931,
			merchantId: 956586,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		at: {
			groupId: 80931,
			merchantId: 274124135,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		}
	},
	fr_CA: {
		gap: {
			groupId: 80931,
			merchantId: 70571,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		on: {
			groupId: 80931,
			merchantId: 202293,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		br: {
			groupId: 80931,
			merchantId: 38986,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		at: {
			groupId: 80931,
			merchantId: 1055652790,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		}
	}
};
var productStyleService$4 = "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience";
var preview = {
	brandCodeUrls: brandCodeUrls$4,
	powerReviewsConfig: powerReviewsConfig$4,
	productStyleService: productStyleService$4
};

var brandCodeUrls$5 = {
	us: {
		gap: {
			secureUrl: "https://{{subdomain}}www.{{contentType}}stage.{{domain}}.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.com",
			productStyleService: "https://stage.api.azeus.gap.com/ux/web/product-style-web-experience"
		},
		br: {
			secureUrl: "https://{{subdomain}}brol.{{contentType}}stage.{{domain}}.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.com",
			productStyleService: "https://stage.api.azeus.gap.com/ux/web/product-style-web-experience"
		},
		on: {
			secureUrl: "https://{{subdomain}}onol.{{contentType}}stage.{{domain}}.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.com",
			productStyleService: "https://stage.api.azeus.gap.com/ux/web/product-style-web-experience"
		},
		at: {
			secureUrl: "https://{{subdomain}}atol.{{contentType}}stage.{{domain}}.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.com",
			productStyleService: "https://stage.api.azeus.gap.com/ux/web/product-style-web-experience"
		},
		gapfs: {
			secureUrl: "https://{{subdomain}}www.{{contentType}}stage.factory-{{domain}}.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.factory-{{domain}}.com",
			productStyleService: "https://stage.api.gapfactory.com/ux/web/product-style-web-experience"
		},
		brfs: {
			secureUrl: "https://{{subdomain}}brfol.{{contentType}}stage.factory-{{domain}}.com",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.factory-{{domain}}.com",
			productStyleService: "https://stage.api.gapfactory.com/ux/web/product-style-web-experience"
		}
	},
	ca: {
		gap: {
			secureUrl: "https://{{subdomain}}www.{{contentType}}stage.{{domain}}.ca",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.ca",
			productStyleService: "https://stage.api.gapcanada.ca/ux/web/product-style-web-experience"
		},
		br: {
			secureUrl: "https://{{subdomain}}brol.{{contentType}}stage.{{domain}}.ca",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.ca",
			productStyleService: "https://stage.api.gapcanada.ca/ux/web/product-style-web-experience"
		},
		on: {
			secureUrl: "https://{{subdomain}}onol.{{contentType}}stage.{{domain}}.ca",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.ca",
			productStyleService: "https://stage.api.gapcanada.ca/ux/web/product-style-web-experience"
		},
		at: {
			secureUrl: "https://{{subdomain}}atol.{{contentType}}stage.{{domain}}.ca",
			oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.ca",
			productStyleService: "https://stage.api.gapcanada.ca/ux/web/product-style-web-experience"
		}
	}
};
var powerReviewsConfig$5 = {
	en_US: {
		gap: {
			groupId: 78519,
			merchantId: 651534,
			apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
		},
		on: {
			groupId: 78519,
			merchantId: 41628,
			apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
		},
		br: {
			groupId: 78519,
			merchantId: 377605,
			apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
		},
		at: {
			groupId: 78519,
			merchantId: 123756,
			apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
		},
		gapfs: {
			groupId: 80934,
			merchantId: 485459,
			apiKey: "491f2f5e-acd0-41e0-bbaf-3748f345f489"
		},
		brfs: {
			groupId: 80934,
			merchantId: 69585,
			apiKey: "491f2f5e-acd0-41e0-bbaf-3748f345f489"
		}
	},
	en_CA: {
		gap: {
			groupId: 80931,
			merchantId: 216454,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		on: {
			groupId: 80931,
			merchantId: 372736,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		br: {
			groupId: 80931,
			merchantId: 956586,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		at: {
			groupId: 80931,
			merchantId: 274124135,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		}
	},
	fr_CA: {
		gap: {
			groupId: 80931,
			merchantId: 70571,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		on: {
			groupId: 80931,
			merchantId: 202293,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		br: {
			groupId: 80931,
			merchantId: 38986,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		},
		at: {
			groupId: 80931,
			merchantId: 1055652790,
			apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
		}
	}
};
var productStyleService$5 = "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience";
var stage = {
	brandCodeUrls: brandCodeUrls$5,
	powerReviewsConfig: powerReviewsConfig$5,
	productStyleService: productStyleService$5
};

var environmentConfigs = {
    default: defaultConfigs,
    local: local,
    preview: preview,
    prod: prod,
    production: prod,
    stage: stage,
    test: test,
};

var getFormattedBrandUrls = function (_a) {
    var environment = _a.environment, config = _a.config, contentType = _a.contentType;
    var preview = contentType === 'wip' || contentType === 'app';
    var dynamicUrl = /{{contentType}}|{{subdomain}}|{{domain}}|{{oidcContentType}}/g;
    var replaceConfig = {
        '{{contentType}}': preview ? contentType + "." : '',
        '{{subdomain}}': (environment === 'stage' || environment === 'local' || environment === 'test') && preview ? 'secure.' : 'secure-',
        '{{domain}}': (environment === 'stage' || environment === 'local' || environment === 'test') && preview
            ? 'gaptecholapps'
            : 'gaptechol',
        '{{oidcContentType}}': (environment === 'stage' || environment === 'local' || environment === 'test') && preview
            ? "preview." + contentType
            : 'live',
    };
    function replacer(matched) {
        return replaceConfig === null || replaceConfig === void 0 ? void 0 : replaceConfig[matched];
    }
    return Object.entries(config).reduce(function (updatedConfig, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        return (__assign(__assign({}, updatedConfig), (_b = {}, _b[key] = value.replace(dynamicUrl, replacer), _b)));
    }, {});
};
var getAddToBagUrl = function (finalConfig, environment, brandAbbr, market, contentType) {
    var config = finalConfig.brandCodeUrls[market][brandAbbr];
    return getFormattedBrandUrls({ environment: environment, config: config, contentType: contentType });
};
var getPssUrl = function (finalConfig, brandAbbr, market, apiHostForward) {
    var config = finalConfig.brandCodeUrls[market][brandAbbr];
    return apiHostForward ? config.productStyleService : finalConfig.productStyleService;
};

/** @jsx jsx */
var useAppState = extendableUseAppState;
function QuickAdd(_a) {
    var _b;
    var apiConfig = _a.apiConfig, brand = _a.brand, clientId = _a.clientId, pid = _a.pid, _c = _a.className, className = _c === void 0 ? '' : _c, onAddToBag = _a.onAddToBag, _d = _a.reportQuickAddStart, reportQuickAddStart = _d === void 0 ? function () { } : _d, _e = _a.enableLegacyAddToBag, enableLegacyAddToBag = _e === void 0 ? false : _e, reviews = _a.reviews, isQuickAddRedesignEnabled = _a.isQuickAddRedesignEnabled, isDropShipEnabled = _a.isDropShipEnabled, _f = _a.isProductRedirectDisabled, isProductRedirectDisabled = _f === void 0 ? false : _f;
    var localize = useLocalize().localize;
    var _g = useAppState(), brandFromAppState = _g.brandName, contentType = _g.contentType, country = _g.country, env = _g.env, errorLogger = _g.errorLogger, locale = _g.locale, market = _g.market;
    var enabledFeatures = useContext(FeatureFlagsContext).enabledFeatures;
    var apiHostForward = enabledFeatures['pdp-apihost-rewrite'];
    var brandName = brand || brandFromAppState;
    var defaultConfig = environmentConfigs.default;
    var environmentConfig = environmentConfigs[env];
    var finalConfig = merge(defaultConfig, environmentConfig);
    var pssUrl = getPssUrl(finalConfig, brandName, market, apiHostForward);
    var powerReviewsConfig = finalConfig.powerReviewsConfig[locale][brandName];
    var addToBagUrls = getAddToBagUrl(finalConfig, env, brandName, market, contentType);
    var _h = useProductStyle({
        apiConfig: apiConfig,
        brand: brandName,
        country: country,
        contentType: contentType,
        market: market,
        locale: locale,
        pid: pid,
        pssUrl: pssUrl,
    }), data = _h.data, status = _h.status;
    var errorComponentJSX = useMemo(function () {
        return (jsx("div", { css: errorMessageStyles, role: "alert" }, localize('quickAdd.error.general')));
    }, [localize]);
    var OOSErrorComponentJSX = useMemo(function () {
        return (jsx("div", { css: errorMessageStyles, role: "alert" }, localize('quickAdd.error.itemOutOfStock')));
    }, [localize]);
    var OOSProduct = data && ((_b = data.variants) === null || _b === void 0 ? void 0 : _b.length) && !data.variants.find(function (variant) { return variant.inStock; });
    var shouldDisplayProductInfoVersion = status === 'complete' && !OOSProduct;
    useMemo(function () {
        status === 'complete' &&
            OOSProduct &&
            errorLogger(new Error("[ERROR] " + clientId + " Quick Add Error message: Out of stock error"));
        status === 'error' &&
            errorLogger(new Error("[ERROR] " + clientId + " Quick Add Error message: Error opening the component"));
    }, [status, OOSProduct, errorLogger, clientId]);
    // This just addresses this requirement: https://gapinc.atlassian.net/browse/EVAL-2775
    var shouldShortenFrenchTexts = useMemo(function () { return data && status === 'complete' && locale === 'fr_CA'; }, [
        data,
        status,
        locale,
    ]);
    var normalizedData = useMemo(function () { return (shouldShortenFrenchTexts ? shortenFrenchLabels(data) : data); }, [
        data,
        shouldShortenFrenchTexts,
    ]);
    return (jsx("div", { className: "quick-add " + className, css: quickAddStyles$2 },
        jsx(ErrorBoundary, { componentName: "Quick Add", errorComponent: errorComponentJSX, errorLogger: errorLogger },
            status === 'complete' && OOSProduct && OOSErrorComponentJSX,
            status === 'error' && errorComponentJSX,
            shouldDisplayProductInfoVersion && (jsx(QuickAddContainerWithProductInfo, { addToBagUrls: addToBagUrls, brandName: brandName, clientId: clientId, data: normalizedData, enableLegacyAddToBag: enableLegacyAddToBag, errorLogger: errorLogger, isDropShipEnabled: isDropShipEnabled, isProductRedirectDisabled: isProductRedirectDisabled, isQuickAddRedesignEnabled: isQuickAddRedesignEnabled, locale: locale, onAddToBag: onAddToBag, pid: pid, powerReviewsConfig: powerReviewsConfig, reportQuickAddStart: reportQuickAddStart, reviews: reviews })))));
}

export default QuickAdd;
export { ADD_TO_BAG_REQUEST, ADD_TO_BAG_RESPONSE, ADD_TO_BAG_SIZE_VALIDATION, AddToBag, DIMENSION_CHANGE, QUANTITY_CHANGE, QuickAdd, VARIANT_CHANGE, getRegularVariants, initQuickAddState, isVariantInStock, quickAddReducer, useAppState };
